import Places from "./Places";
import Place from "./Place";
import GuideDocument, { NextPage } from "./Document";
import Group from "./Group";
import CustomIcon from "./CustomIcon";
import Category from "./Category";
import Schedule from "./Schedule";
import { html_entity_decode } from "../Common/Common_d";
import Common, { Settings, SortByEnum, labelChars, AUTHORIZATION_LEVEL, COLORS, isSearchResult } from "../Common/Common";
import React, { Component } from "react";
import { countries,  countries_continents, regions} from "../Data/Countries";

import Chapter from "../Models/Chapter";
import { DateTime } from "luxon";
import { KMLTemplate } from "../Data/KMLTemplate";
import Section from "./Section";

export class GuideAttributes {
  constructor(guide_name, description, image, language, rating, countries, cities) {
    this.guide_id = "new";
    this.guide_name = guide_name;
    this.description = description;
    this.image = image;
    this.image_m = "";
    this.language = language;
    this.access = [];
    //this.price = "0";
    this.rating = rating;
    //this.ratings = "";
    //this.start_date = "";
    //this.end_date = "";
    this.owner_name = "";
    this.user_id = "";
    this.creator_id = "";
    this.countries = countries;
    this.cities = cities;
    this.mod = DateTime.now().toISO({ zone: "utc" }); //"2013-04-22 19:40:51";
    this.created = this.mod;
    this.read = this.mod;
    this.copy = this.mod;
    this.num_ratings = 0;
    this.times_read = 0;
    this.times_copied = 0;
    this.base_location = { latitude: 43.7, longitude: 11.2 };
    this.type = "";
  }

  decodeAttributes(attributes) {
    this.guide_id = attributes.guide_id;
    this.guide_name = attributes.guide_name;
    this.description = attributes.description;
    this.image = attributes.image;
    this.image_m = attributes.image_m;
    this.language = attributes.language;
    this.access = attributes.access;
    this.rating = attributes.rating;
    this.owner_name = attributes.owner_name;
    this.user_id = attributes.user_id;
    this.creator_id = attributes.creator_id;
    this.countries = attributes.countries;
    this.cities = attributes.cities;
    this.mod = DateTime.fromISO(attributes.mod, { zone: "utc" });
    this.created = DateTime.fromISO(attributes.created, { zone: "utc" });
    this.read = DateTime.fromISO(attributes.read, { zone: "utc" });
    this.copy = DateTime.fromISO(attributes.copy, { zone: "utc" });
    this.num_ratings = attributes.num_ratings;
    this.times_read = attributes.times_read;
    this.times_copied = attributes.times_copied;
    this.base_location = attributes.base_location;
    this.type = attributes.type;
    if (typeof this.type === "undefined") this.type = "";
    const index = this.access.findIndex((x) => x === "Featured");
    if (index !== -1) {
      //this.access = this.access.splice(index, 1);
      this.type = "Featured";
    }
  }
  modifyGuideAttributes(attributes) {
    //console.log("modifyGuideAttributes", attributes);
    this.guide_name = attributes.guide_name;
    this.description = attributes.description;
    this.image = attributes.image;
    this.image_m = attributes.image_m;
    this.language = attributes.language;
    this.access = attributes.access;
    this.rating = attributes.rating;
    // Callers (GuideEditModal/BuildMyTripWizard/etc.) never pass a mod field —
    // preserve the existing value instead of clobbering it with undefined,
    // which would silently disable the save-conflict check's version compare.
    if (typeof attributes.mod !== "undefined") this.mod = attributes.mod;
    this.countries = attributes.countries;
    this.cities = attributes.cities;
    this.base_location = attributes.base_location;
    this.type = attributes.type;
    if (typeof this.type === "undefined") this.type = "";
    this.comment_count = attributes.comment_count;

    // //console.log("modifyGuideAttributes", this.attributes);
  }
}

let _initial_groups = [
  { id: "0", name: "Accomodation", poi_img: "140", alias: [] },
  { id: "1", name: "Architecture", poi_img: "4", alias: [] },
  { id: "2", name: "Area", poi_img: "31", alias: [] },
  { id: "3", name: "Attraction", poi_img: "195", alias: [] },
  { id: "4", name: "City", poi_img: "16", alias: [] },
  { id: "5", name: "Entertainment", poi_img: "141", alias: [] },
  { id: "6", name: "Family & Kids", poi_img: "43", alias: [] },
  { id: "7", name: "Historical", poi_img: "85", alias: [] },
  { id: "8", name: "Landmark", poi_img: "129", alias: [] },
  { id: "9", name: "Museum", poi_img: "90", alias: [] },
  { id: "10", name: "Nearby", poi_img: "151", alias: [] },
  { id: "11", name: "Neighborhood", poi_img: "152", alias: [] },
  { id: "12", name: "Religion", poi_img: "30", alias: ["Religious sites"] },
  { id: "13", name: "Restaurant", poi_img: "139", alias: [] },
  { id: "14", name: "Shopping", poi_img: "127", alias: [] },
  { id: "15", name: "Sport", poi_img: "160", alias: ["Sports & outdoors", "Race course"] },
  { id: "16", name: "Transport", poi_img: "19", alias: [] },
  { id: "17", name: "Town", poi_img: "177", alias: [] },
  { id: "18", name: "State", poi_img: "197", alias: [] },
  { id: "19", name: "Country", poi_img: "164", alias: [] },
  { id: "20", name: "Highlight", poi_img: "204", alias: [] },
  { id: "21", name: "Photo", poi_img: "208", alias: [] },
  { id: "22", name: "Audio", poi_img: "209", alias: [] },
  { id: "23", name: "Video", poi_img: "210", alias: [] },
  { id: "24", name: "Info", poi_img: "211", alias: [] },
];
let _initial_categories = [
  { id: "0", name: "Accomodation", poi_img: "80", alias: [] },
  { id: "1", name: "Airport", poi_img: "2", alias: [] },
  { id: "2", name: "Appartment", poi_img: "80", alias: [] },
  { id: "3", name: "Arts", poi_img: "141", alias: [] },
  { id: "4", name: "Bank", poi_img: "8", alias: [] },
  { id: "5", name: "Beach", poi_img: "12", alias: [] },
  { id: "6", name: "Bridge", poi_img: "142", alias: [] },
  { id: "7", name: "Cemetery", poi_img: "29", alias: [] },
  { id: "8", name: "Church", poi_img: "30", alias: [] },
  { id: "9", name: "City", poi_img: "16", alias: [] },
  { id: "10", name: "Country", poi_img: "164", alias: [] },
  { id: "11", name: "Day Trip", poi_img: "147", alias: [] },
  { id: "12", name: "Entertainment", poi_img: "141", alias: [] },
  { id: "13", name: "Excursion", poi_img: "147", alias: ["Adventure"] },
  { id: "14", name: "Flight", poi_img: "2", alias: [] },
  { id: "15", name: "Historical", poi_img: "5", alias: [] },
  { id: "16", name: "Hotel", poi_img: "140", alias: [] },
  { id: "17", name: "Golf", poi_img: "145", alias: [] },
  { id: "18", name: "Kids", poi_img: "149", alias: [] },
  { id: "19", name: "Leisure", poi_img: "150", alias: [] },
  { id: "20", name: "Market", poi_img: "35", alias: [] },
  { id: "21", name: "Monument", poi_img: "85", alias: ["Memorial"] },
  { id: "22", name: "Museum", poi_img: "90", alias: [] },
  { id: "23", name: "Nearby", poi_img: "151", alias: [] },
  { id: "24", name: "Neighborhood", poi_img: "152", alias: [] },
  { id: "25", name: "Nightlife", poi_img: "153", alias: [] },
  { id: "26", name: "Outdoors", poi_img: "154", alias: [] },
  { id: "27", name: "Palace", poi_img: "25", alias: [] },
  { id: "28", name: "Park", poi_img: "3", alias: [] },
  { id: "29", name: "Restaurant", poi_img: "139", alias: [] },
  { id: "30", name: "Rest. Chinese", poi_img: "111", alias: [] },
  { id: "31", name: "Rest. Fast Food", poi_img: "148", alias: ["Food & drinks"] },
  { id: "32", name: "Rest. French", poi_img: "155", alias: [] },
  { id: "33", name: "Rest. Indian", poi_img: "114", alias: [] },
  { id: "34", name: "Rest. Italian", poi_img: "115", alias: [] },
  { id: "35", name: "Rest. Japanese", poi_img: "156", alias: [] },
  { id: "36", name: "Rest. Mexican", poi_img: "118", alias: [] },
  { id: "37", name: "Rest. Pizza", poi_img: "157", alias: [] },
  { id: "38", name: "Rest. Seafood", poi_img: "112", alias: [] },
  { id: "39", name: "Rest. Thai", poi_img: "119", alias: [] },
  { id: "40", name: "Rest. Vegan", poi_img: "120", alias: [] },
  { id: "41", name: "Rest. Vegeterian", poi_img: "120", alias: [] },
  { id: "42", name: "Shop", poi_img: "7", alias: [] },
  { id: "43", name: "Sport", poi_img: "160", alias: [] },
  { id: "44", name: "Square", poi_img: "31", alias: [] },
  { id: "45", name: "Street", poi_img: "122", alias: ["Streets and squares"] },
  { id: "46", name: "Theater", poi_img: "141", alias: [] },
  { id: "47", name: "Transport", poi_img: "19", alias: [] },
  { id: "48", name: "Trail", poi_img: "162", alias: [] },
  { id: "49", name: "Walk", poi_img: "136", alias: [] },
  { id: "50", name: "Architecture", poi_img: "4", alias: [] },
  { id: "51", name: "Arts & Culture", poi_img: "141", alias: ["Cultural sites"] },
  { id: "52", name: "Gelato", poi_img: "143", alias: [] },
  { id: "53", name: "Search", poi_img: "165", alias: [] },
  { id: "54", name: "Bakery", poi_img: "166", alias: [] },
  { id: "55", name: "Bar", poi_img: "11", alias: ["Bars & clubs"] },
  { id: "56", name: "Pub", poi_img: "9", alias: [] },
  { id: "57", name: "Rest. Meat", poi_img: "167", alias: [] },
  { id: "58", name: "Rest. Venezuela", poi_img: "168", alias: [] },
  { id: "59", name: "Town", poi_img: "177", alias: [] },
  { id: "60", name: "Cinema", poi_img: "181", alias: [] },
  { id: "61", name: "Dancing", poi_img: "182", alias: [] },
  { id: "62", name: "Wild Life", poi_img: "182", alias: ["Wildlife"] },
  { id: "63", name: "Fishing", poi_img: "184", alias: [] },
  { id: "64", name: "Geyser", poi_img: "185", alias: [] },
  { id: "65", name: "Glacier", poi_img: "186", alias: [] },
  { id: "66", name: "Hot Spring", poi_img: "188", alias: [] },
  { id: "67", name: "Music", poi_img: "191", alias: [] },
  { id: "68", name: "View", poi_img: "193", alias: ["Viewpoints"] },
  { id: "69", name: "Ruins", poi_img: "194", alias: [] },
  { id: "70", name: "Small City", poi_img: "196", alias: [] },
  { id: "71", name: "State", poi_img: "197", alias: [] },
  { id: "72", name: "Statue", poi_img: "198", alias: [] },
  { id: "73", name: "Volcano", poi_img: "200", alias: [] },
  { id: "74", name: "Synagogue", poi_img: "199", alias: [] },
  { id: "75", name: "Waterfall", poi_img: "201", alias: [] },
  { id: "76", name: "Wetlands", poi_img: "202", alias: [] },
  { id: "77", name: "River", poi_img: "121", alias: [] },
  { id: "78", name: "Lake", poi_img: "50", alias: [] },
  { id: "79", name: "Camping", poi_img: "22", alias: [] },
  { id: "80", name: "Castle", poi_img: "25", alias: [] },
  { id: "81", name: "Cathedral", poi_img: "26", alias: [] },
  { id: "82", name: "Cave", poi_img: "28", alias: ["Caverns & caves"] },
  { id: "83", name: "Coffee", poi_img: "33", alias: [] },
  { id: "84", name: "Store", poi_img: "35", alias: [] },
  { id: "85", name: "Desert", poi_img: "40", alias: [] },
  { id: "86", name: "Home", poi_img: "45", alias: [] },
  { id: "87", name: "Hospital", poi_img: "47", alias: [] },
  { id: "88", name: "Library", poi_img: "78", alias: [] },
  { id: "89", name: "Lighthouse", poi_img: "79", alias: ["Light house"] },
  { id: "90", name: "Marina", poi_img: "82", alias: [] },
  { id: "91", name: "Mosque", poi_img: "86", alias: [] },
  { id: "92", name: "Mountain", poi_img: "87", alias: [] },
  { id: "93", name: "Parking", poi_img: "104", alias: [] },
  { id: "94", name: "Playground", poi_img: "106", alias: [] },
  { id: "95", name: "Resort", poi_img: "110", alias: [] },
  { id: "96", name: "Road", poi_img: "122", alias: [] },
  { id: "97", name: "Taxi", poi_img: "128", alias: [] },
  { id: "98", name: "Toilets", poi_img: "130", alias: [] },
  { id: "99", name: "Train", poi_img: "131", alias: [] },
  { id: "100", name: "Tramway", poi_img: "132", alias: [] },
  { id: "101", name: "Zoo", poi_img: "138", alias: ["Zoos & aquariums"] },
  { id: "102", name: "Ice Cream", poi_img: "143", alias: [] },
  { id: "103", name: "Canyon", poi_img: "180", alias: [] },
  { id: "104", name: "Highlight", poi_img: "204", alias: ["Must see"] },
  { id: "105", name: "Attraction", poi_img: "195", alias: [] },
  { id: "106", name: "Landmark", poi_img: "129", alias: ["Sculptures"] },
  { id: "107", name: "Family & Kids", poi_img: "43", alias: [] },
  { id: "108", name: "Concerts & shows", poi_img: "141", alias: [] },
  { id: "109", name: "Religious site", poi_img: "30", alias: [] },
  { id: "110", name: "Shopping", poi_img: "127", alias: [] },
  { id: "111", name: "School", poi_img: "124", alias: ["Educational sites"] },
  { id: "112", name: "Geographical feature", poi_img: "193", alias: [] },
  { id: "113", name: "Island", poi_img: "205", alias: [] },
  { id: "114", name: "Building", poi_img: "206", alias: ["Convention center"] },
  { id: "115", name: "Casino", poi_img: "207", alias: ["Casinos & gambling"] },
  { id: "116", name: "Ski", poi_img: "125", alias: ["Ski resort"] },
  { id: "117", name: "Photo", poi_img: "208", alias: [] },
  { id: "118", name: "Audio", poi_img: "209", alias: [] },
  { id: "119", name: "Video", poi_img: "210", alias: [] },
  { id: "120", name: "Info", poi_img: "211", alias: [] },
  { id: "121", name: "Garden", poi_img: "212", alias: ["Gardens"] },
  { id: "122", name: "Forest", poi_img: "213", alias: [] },
  { id: "123", name: "Aquarium", poi_img: "214", alias: [] },
  { id: "124", name: "Theme park", poi_img: "215", alias: ["Amusement Park", "Water Park"] },
  { id: "125", name: "Stadium", poi_img: "126", alias: ["Sports & outdoors"] },
  { id: "126", name: "Kayaking", poi_img: "49", alias: [] },
  { id: "127", name: "Climbing", poi_img: "49", alias: ["Mountain climbing"] },
  { id: "128", name: "Biking", poi_img: "15", alias: ["Cycling"] },
  { id: "129", name: "Horse riding", poi_img: "15", alias: [] },
  { id: "130", name: "Boating", poi_img: "18", alias: [] },
  { id: "131", name: "Swimmming", poi_img: "12", alias: [] },
  { id: "132", name: "Surfing", poi_img: "219", alias: [] },
  { id: "133", name: "Horse Racing", poi_img: "15", alias: [] },
  { id: "134", name: "Farm", poi_img: "220", alias: [] },
  { id: "135", name: "Factory", poi_img: "221", alias: [] },
  { id: "136", name: "Science", poi_img: "222", alias: [] },
  { id: "137", name: "Science Museum", poi_img: "222", alias: [] },
  { id: "138", name: "Parades", poi_img: "141", alias: [] },
  { id: "139", name: "Carnivals", poi_img: "141", alias: [] },
  { id: "140", name: "Fair", poi_img: "141", alias: [] },
  { id: "141", name: "Wineries & vineyards", poi_img: "137", alias: [] },
  { id: "142", name: "Race course", poi_img: "126", alias: [] },
  { id: "143", name: "Sightseeing", poi_img: "147", alias: [] },
  { id: "144", name: "Art", poi_img: "223", alias: [] },
  { id: "145", name: "Art gallery", poi_img: "223", alias: [] },
  { id: "146", name: "Observatory", poi_img: "224", alias: [] },
  { id: "147", name: "Planetarium", poi_img: "224", alias: [] },
  { id: "148", name: "Wine", poi_img: "137", alias: [] },
  { id: "149", name: "Brewery", poi_img: "225", alias: [] },
  { id: "150", name: "Distillary", poi_img: "225", alias: [] },
  { id: "151", name: "Hiking trail", poi_img: "136", alias: [] },
  { id: "152", name: "Hiking", poi_img: "136", alias: [] },
  { id: "153", name: "Fort", poi_img: "25", alias: [] },
  { id: "154", name: "Monorail", poi_img: "131", alias: [] },
  { id: "155", name: "Scenic drive", poi_img: "193", alias: [] },
  { id: "156", name: "Sports Venue", poi_img: "126", alias: [] },
  { id: "157", name: "Landscape", poi_img: "212", alias: [] },
  { id: "158", name: "Ancient", poi_img: "194", alias: [] },
  { id: "159", name: "Festival", poi_img: "141", alias: [] },
  { id: "160", name: "Nature", poi_img: "154", alias: [] },
  { id: "161", name: "Culinary", poi_img: "148", alias: [] },
  { id: "162", name: "Food", poi_img: "148", alias: [] },
  { id: "163", name: "Spa", poi_img: "150", alias: [] },
  { id: "164", name: "Villa", poi_img: "25", alias: [] },
  { id: "165", name: "Canoeing", poi_img: "49", alias: [] },
  { id: "166", name: "Rafting", poi_img: "49", alias: [] },
  { id: "167", name: "Botanical", poi_img: "212", alias: [] },
];

let GuideSettings = {
  mode: "custom_view", // "edit" "view" "custom_view" — home-page rendering format (Mosaic grid vs Custom document) ONLY. See click_behavior below for click-handling.
  // Decoupled from `mode` 2026-10-05 — previously a single click on a place
  // card/map marker/guide card/schedule name/day section only ran the
  // places_list/places_map/event/schedule/day toggles below when mode was
  // "custom_view", conflating "which home-page format" with "which click
  // behavior" into one field. Existing guides saved before this field
  // existed are migrated on load (see reducer.js) to whichever value
  // preserves their current visible behavior exactly.
  // Default (not Custom) for brand-new guides, 2026-10-05 — now that
  // "Default" itself shows Place Details on a click/tap (see PlaceCard.js/
  // Map.js), there's no need for a new guide to start in "Custom" just to
  // get that; it also means the Settings dialog opens simpler (the List/Map/
  // Schedule/Day Click toggle sections are hidden under "Default").
  click_behavior: "default", // "default" "custom"
  zoom: 5,
  hide_schedule: false,
  hide_hidden: false,
  wrap_text: false,
  // "Show photo icons" (Map Menu) — used to be plain component state in
  // Map.js, forgotten on every reload/guide switch. A per-guide setting now,
  // same durability as every other GuideSettings field (persists whenever
  // the guide itself is next saved).
  show_photo_icons: false,
  // Both default to "Display Details" rather than the long action menu
  // (places_list/places_map.menu) — simplification requested 2026-10-05.
  // `info` is off so a place WITH notes doesn't silently preempt Details
  // (placeSelected/infoWindowClicked check info before attributes); a user
  // who wants Notes shown instead can still turn that toggle on in Guide
  // Settings. Only affects brand-new guides — an existing guide's saved
  // guide_settings already has its own values for all of these.
  places_list: {
    menu: false,
    info: false,
    url: false,
    attributes: true,
    center: true,
    filter: false,
    path_link: false,
  },
  places_map: {
    menu: false,
    info: false,
    url: false,
    attributes: true,
    center: false,
    filter: false,
    // Was on by default so a Path carrying a real link (e.g. the Google
    // Maps directions link a drawn Path now gets — DirectionsDialogComponent.js)
    // opened on a map click without needing this turned on manually — but
    // infoWindowClicked checks path_link before attributes, so leaving it on
    // would silently preempt the new Display Details default for EVERY
    // marker, not just Paths. Off by default now; a guide that relies on
    // Path click-to-open-link needs to turn this on explicitly.
    path_link: false,
    number: true,
  },
  places_map_hover: {
    menu: false,
    place: true,
    info: true,
    event: true,
  },
  event: {
    menu: false,
    details: true,
    center: true,
    filter: false,
  },
  schedule: {
    menu: false,
    itinerary: true,
    center: false,
    filter: true,
  },
  day: {
    menu: false,
    center: false,
    filter: true,
  },
  itinerary: {
    directions: true,
    info: true,
    photo: true,
    place_menu: true,
    weather: true,
    climate: true,
  },
};
export default class Guide {
  constructor(guide_id) {
    this.guide_id = guide_id;
    this.places = new Places();
    this.schedule = new Schedule();
    this.chapters = [];
    //this.journal = "";
    this.document = "Nothing here yet. Add destinations to build your trip, or tap Edit to write this page yourself."; // plain wording (2026-10-23)
    this.groups = JSON.parse(JSON.stringify(_initial_groups));
    this.categories = JSON.parse(JSON.stringify(_initial_categories));
    // {id, city, country, dateStart, dateEnd (Luxon DateTime, UTC-tagged
    // wall-clock — same convention as mod/created/read/copy below),
    // hasTransportTimes} — see the Destinations-first redesign. Luxon's
    // DateTime.toJSON() returns .toISO(), so this round-trips through
    // JSON.stringify (batchedWriteGuide's serialization) with no separate
    // encode step; decodeGuideFb below converts the ISO strings back.
    this.destinations = [];
    // {TripType, TripTypeSelected, travelingWith, travelingWithSelected,
    // focusOn, focusONSelected, Activities, ActivitiesSelected,
    // selectedBudget, selectedPace, selectedTransportation,
    // includeExcursions} or null — the last preferences used to generate
    // destinations via "Destinations from AI" (AIDestinationsFlow.js),
    // persisted so TripAI.js can pre-fill from them every time it opens for
    // this guide, not just once. Plain strings/arrays, no Luxon fields, so no
    // special encode/decode is needed — round-trips through JSON.stringify
    // like everything else in guide_data.
    this.aiPreferences = null;
    // Print Photo Book's arrangement (2026-10-17): page order, crops, pages
    // left out, custom text pages and the maps choice, so reopening the
    // book restores it — see Common/PhotoBook.js's applyPhotoBookLayout.
    // Plain JSON, saved with the guide.
    this.photoBookLayout = null;
    // {id, number, label} — a trip can have multiple flights (outbound,
    // return, connections), so this is a list, not a single "current
    // flight". Plain strings, no Luxon fields, so no special encode/decode
    // is needed — round-trips through JSON.stringify like aiPreferences.
    this.flights = [];
    // {id, name} — a lightweight, guide-scoped roster of plain names (not
    // app accounts) for splitting expenses among (Expense Tracking MVP,
    // docs/competitive-analysis.md). Deliberately NOT user_info.travelers
    // (TravelersDialog.js) — that roster is USER-scoped with passport/visa
    // documents and reused across all of that user's guides; this is
    // per-guide and name-only. Plain strings, no Luxon fields, so no
    // special encode/decode is needed — round-trips through
    // JSON.stringify like aiPreferences/flights above.
    this.tripMembers = [];
    // {id, amount, currency, categoryId, placeId, eventKey, date, paidBy,
    // splits, note} — one record per expense. categoryId resolves against
    // this.categories (same id space Place.Category uses). placeId is a
    // Place.ID (stable); eventKey is an Event.CommentKey (or
    // stableEventKey(item) fallback — see GuideDiff.js), stable across
    // decode unlike Event.ID, same reasoning CommentsSection.js's
    // getTargetId already documents — at most one of placeId/eventKey is
    // set. paidBy and splits[].memberId reference tripMembers[].id. splits
    // is [{memberId, percent}], percents summing to 100 (equal split is
    // just 100/N on every participant; someone who wasn't there is 0% or
    // omitted). No Luxon fields — date is a plain ISO string — so, like
    // tripMembers above, no special encode/decode step is needed.
    this.expenses = [];
    this.attributes = new GuideAttributes("New", "New Guide", "", "English", 0, [], []);
    this.custom_icons = [];
    this.guide_settings = GuideSettings;
  }

  setGuideSettings(GuideSettings) {
    this.guide_settings = GuideSettings;
  }

  getCategoryByName(name, from) {
    if (name === null || typeof name === "undefined") return null;
    if (from === "guide") {
      for (let i = 0; i < this.categories.length; i++) {
        if (
          this.categories[i].name.toUpperCase() === name.toUpperCase() ||
          (this.categories[i].name + "s").toUpperCase() === name.toUpperCase()
        )
          return this.categories[i];
      }
      return null;
    } else if (from === "initial") {
      for (let i = 0; i < _initial_categories.length; i++) {
        if (
          _initial_categories[i].name.toUpperCase() === name.toUpperCase() ||
          (_initial_categories[i].name + "s").toUpperCase() === name.toUpperCase()
        )
          return _initial_categories[i];
        for (let j = 0; j < _initial_categories[i].alias.length; j++)
          if (_initial_categories[i].alias[j].toUpperCase() === name.toUpperCase()) return _initial_categories[i];
      }
      return null;
    }
    return null;
  }

  getGroupByName(name, from) {
    if (name === null || typeof name === "undefined") return null;
    if (from === "guide") {
      for (let i = 0; i < this.groups.length; i++) {
        if (
          this.groups[i].name.toUpperCase() === name.toUpperCase() ||
          (this.groups[i].name + "s").toUpperCase() === name.toUpperCase()
        )
          return this.groups[i];
      }
    } else if (from === "initial") {
      for (let i = 0; i < _initial_groups.length; i++) {
        if (
          _initial_groups[i].name.toUpperCase() === name.toUpperCase() ||
          (_initial_groups[i].name + "s").toUpperCase() === name.toUpperCase()
        )
          return _initial_groups[i];
        for (let j = 0; j < _initial_groups[i].alias.length; j++)
          if (_initial_groups[i].alias[j].toUpperCase() === name.toUpperCase()) return _initial_groups[i];
      }
    }
    return null;
  }

  getGroupByID(ID, from) {
    if (ID === null || typeof ID === "undefined") return null;
    if (from === "guide") {
      for (let i = 0; i < this.groups.length; i++) {
        if (
          this.groups[i].id === ID)
          return this.groups[i];
      }
    } 
    return null;
  }

  getCustomIconsToDisplay() {
    let iconsList = [];
    for (let i = 0; i < this.custom_icons.length; i++) {
      iconsList.push({
        id: this.custom_icons[i].id,
        name: this.custom_icons[i].name,
        label: this.custom_icons[i].name,
        icon: this.custom_icons[i].poi_img,
        value: this.custom_icons[i].url,
        obj: this.custom_icons[i],
      });
    }
    iconsList = iconsList.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
    return iconsList;
  }

  addCustomIcon(group_name) {
    const group = new CustomIcon(this.custom_icons, group_name);
    this.custom_icons.push(group);
  }

  modifyCustomIcon(oldGroup, newGroup) {
    let index = this.custom_icons.findIndex((x) => x.id == oldGroup.id);
    if (index != -1) {
      this.custom_icons[index].name = newGroup.name;
      this.custom_icons[index].poi_img = newGroup.poi_img;
      this.custom_icons[index].url = newGroup.url;
    }
  }

  deleteCustomIcon(group) {
    //console.log("deleteGroup", group);
    const index = this.custom_icons.findIndex((x) => x.id == group.id);
    if (index == -1) return;
    this.custom_icons.splice(index, 1);
    //console.log("deleteGroup index", index);
    //this.places.deletePlaceGroup(group.id);
  }

  modifyGuideAttributes(attributes) {
    //console.log("modifyGuideAttributes", attributes);
    this.attributes.guide_name = attributes.guide_name;
    this.attributes.description = attributes.description;
    this.attributes.image = attributes.image;
    this.attributes.image_m = attributes.image_m;
    this.attributes.language = attributes.language;
    this.attributes.access = attributes.access;
    // attributes.mod is NOT part of what this caller edits (GuideEditModal's
    // name/description/access/etc. form has no mod field) — preserve the
    // existing value instead of clobbering it with undefined, which would
    // silently disable the save-conflict check's version comparison.
    if (typeof attributes.mod !== "undefined") this.attributes.mod = attributes.mod;
    this.attributes.rating = attributes.rating;
    this.attributes.countries = attributes.countries;
    this.attributes.cities = attributes.cities;
    this.base_location = attributes.base_location;
    this.type = attributes.type;
    if (typeof this.type === "undefined") this.type = "";
    this.attributes.comment_count = attributes.comment_count;

    // //console.log("modifyGuideAttributes", this.attributes);
  }

  setAuthorization(guide_info, uid) {
    //console.log("setAuthorization", "uid:", uid);
    // A brand-new, not-yet-saved guide (createLocalGuide's in-memory path)
    // has no cloud guide_info doc yet — nobody else could have any claim on
    // it, so whoever just created it (guest or signed-in) always has full
    // access.
    if (guide_info == null) return AUTHORIZATION_LEVEL.MODIFY;
    if (guide_info.user_id === uid) return AUTHORIZATION_LEVEL.MODIFY;
    // Ownership (above) must be checked before this blanket guest downgrade
    // — previously checked first, which capped a guest's OWN guides (once
    // saved to Firestore under user_id: "guest") at GUEST(2) instead of
    // MODIFY, hiding every Authorization >= COPY action even for a guide
    // the guest fully owns. Still applies here for a guide a guest does NOT
    // own (e.g. the shared default/sample guide). Same fix as mobile's
    // Guide.js. Found 2026-09-26.
    if (uid === "guest") return AUTHORIZATION_LEVEL.GUEST;
    let Auth = AUTHORIZATION_LEVEL.NONE;
    let ShareAll = AUTHORIZATION_LEVEL.NONE;
    if (!Array.isArray(guide_info.access)) return AUTHORIZATION_LEVEL.NONE;
    const _access = Guide.cleanAccess(guide_info.access);
    let highest_access = AUTHORIZATION_LEVEL.NONE;
    _access.forEach((access) => {
      if (access == "All_R") ShareAll = AUTHORIZATION_LEVEL.READ;
      else if (access == "All_C") ShareAll = AUTHORIZATION_LEVEL.COPY;
      else if (access == "All_M") ShareAll = AUTHORIZATION_LEVEL.MODIFY;
      if (access == uid) Auth = AUTHORIZATION_LEVEL.MODIFY;
      else if (access.includes(":")) {
        let access_parts = access.split(":");
        if (access_parts[1] == "R") {
          if (access_parts[0] == uid) Auth = AUTHORIZATION_LEVEL.READ;
        } else if (access_parts[1] == "C") {
          if (access_parts[0] == uid) Auth = AUTHORIZATION_LEVEL.COPY;
        } else if (access_parts[1] == "M") {
          if (access_parts[0] == uid) Auth = AUTHORIZATION_LEVEL.MODIFY;
        }
      }
      if (Auth == AUTHORIZATION_LEVEL.MODIFY) return Auth;
      if (highest_access == AUTHORIZATION_LEVEL.COPY && Auth == AUTHORIZATION_LEVEL.READ)
        Auth = AUTHORIZATION_LEVEL.COPY; //keep Copy because it's higher
      highest_access = Auth;
    });
    if (Auth == AUTHORIZATION_LEVEL.NONE) Auth = ShareAll;
    return Auth;
  }
  // "All"
  // "I Own",
  // "Shared by me: Read",
  // "Shared by me: Copy",
  // "Shared by me: Modify",
  // "Shared to me: Read",
  // "Shared to me: Copy",
  // "Shared to me: Modify",
  // "Shared by community: Read",
  // "Shared by community: Copy",
  // "Shared by community: Modify",
  // "Shared to community by me: Read",
  // "Shared to community by me: Copy",
  // "Shared to community by me: Modify",

  classifyAuthorization(guide_infos, uid) {
    //console.log("classifyAuthorization", guide_infos, uid);
    if (guide_infos == null) return guide_infos;
    //let _guide_infos = JSON.parse(JSON.stringify(guide_infos));
    let i_own = false;
    guide_infos.forEach((guide_info_data) => {
      let guide_info = guide_info_data.data;
      guide_info_data.data = this.classifyAuthorizationInfo(guide_info, uid);
    });
    return guide_infos;
  }
  classifyAuthorizationInfo(guide_info, uid) {
    //console.log("classifyAuthorizationInfo", guide_info, uid);
    let guide_info_copy = JSON.parse(JSON.stringify(guide_info));
    let i_own = false;
    // //console.log("guide_info_copy", guide_info_copy);
    guide_info_copy.categories = [];
    //guide_info_copy.accessRight = AUTHORIZATION_LEVEL.NONE;
    if (typeof guide_info_copy.access == "undefined") {
      // //console.log("guide_info_copy", guide_info_copy);
      guide_info_copy.categories.push("All");
      // //console.log("typeof guide_info_copy.access == "undefined");
      return guide_info_copy;
    }
    const access = Guide.cleanAccess(guide_info_copy.access);
    // //console.log("access", access);

    guide_info_copy.access_summary = "";
    if (access.includes(uid) || guide_info_copy.user_id === uid) {
      guide_info_copy.categories.push("Mine");
      guide_info_copy.access_summary = "Mine";
      i_own = true;
    }
    let highest_access = "None";
    access.forEach((access) => {
      if (access == "Featured") guide_info_copy.categories.push("Featured");
      if (access == "All_R")
        if (guide_info_copy.user_id == uid) {
          guide_info_copy.categories.push("I shared to community: Read");
          guide_info_copy.access_summary = "To community: Read";
        } else {
          guide_info_copy.categories.push("Shared by community: Read");
          guide_info_copy.access_summary = "From community: Read";
        }
      else if (access == "All_C")
        if (guide_info_copy.user_id == uid) {
          guide_info_copy.categories.push("I shared to community: Copy");
          guide_info_copy.access_summary = "To community: Copy";
        } else {
          guide_info_copy.categories.push("Shared by community: Copy");
          guide_info_copy.access_summary = "From community: Copy";
        }
      else if (access == "All_M")
        if (guide_info_copy.user_id == uid) {
          guide_info_copy.categories.push("I shared to community: Modify");
          guide_info_copy.access_summary = "To community: Modify";
        } else {
          guide_info_copy.categories.push("Shared by community: Modify");
          guide_info_copy.access_summary = "From community: Modify";
        }

      if (access.includes(":")) {
        let access_parts = access.split(":");
        if (access_parts[1] == "R") {
          if (access_parts[0] == uid) {
            guide_info_copy.categories.push("Shared to me: Read");
            guide_info_copy.access_summary = "To me: Read";
          } else if (i_own) guide_info_copy.categories.push("I shared to a few: Read"); // this.accessCategory("Shared by me: Read", access_parts[0], guide_info_copy); //
        } else if (access_parts[1] == "C") {
          if (access_parts[0] == uid) {
            guide_info_copy.categories.push("Shared to me: Copy");
            guide_info_copy.access_summary = "To me: Copy";
          } else if (i_own) guide_info_copy.categories.push("I shared to a few: Copy"); //this.accessCategory("Shared by me: Copy", access_parts[0], guide_info_copy);
        } else if (access_parts[1] == "M") {
          if (access_parts[0] == uid) {
            guide_info_copy.categories.push("Shared to me: Modify");
            guide_info_copy.access_summary = "To me: Modify";
          } else if (i_own) guide_info_copy.categories.push("I shared to a few: Modify"); //this.accessCategory("Shared by me: Modify", access_parts[0], guide_info_copy); //
        }
      }
    });
    return guide_info_copy;
  }

  // Pure, static — unlike classifyAuthorizationInfo (which buckets a
  // personal "uid:M" grant and a community "All_M" grant under two
  // DIFFERENT, mutually-exclusive labels — "To me: X" vs "From community:
  // X"), the Shared-tab filter needs both to count as the same "To me: X"
  // access level, taking the highest of the two when a guide has both
  // (mirrors setAuthorization's own precedence of personal-vs-ShareAll).
  // Legacy guide_info docs can have access: null or non-string entries
  // (e.g. a guide saved before it had an owner); one such doc crashed the
  // whole Library "Mine" tab. Found 2026-10-06.
  static cleanAccess(access) {
    return Array.isArray(access) ? access.filter((a) => typeof a === "string") : [];
  }

  // Owner, or granted access BY NAME (bare uid, uid:R/C/M) — community
  // "Share with all" grants (All_*) don't count. Matches the Firestore
  // rules' hasPersonalAccess (poll creation).
  static hasPersonalAccess(guide_info, uid) {
    if (!guide_info || !uid || uid === "guest") return false;
    if (guide_info.user_id === uid) return true;
    return Guide.cleanAccess(guide_info.access).some((a) => a === uid || a === `${uid}:R` || a === `${uid}:C` || a === `${uid}:M`);
  }

  // Owner, or MODIFY granted BY NAME (bare uid or uid:M) — community
  // "Modify for all" (All_M) doesn't count. Gates moderation (deleting
  // others' comments, closing/deleting polls), matching the Firestore
  // rules' hasPersonalModifyAccess. 2026-10-09: with All_M counting, any
  // signed-in stranger could delete a public guide's whole discussion.
  static hasPersonalModifyAccess(guide_info, uid) {
    if (!guide_info || !uid || uid === "guest") return false;
    if (guide_info.user_id === uid) return true;
    return Guide.cleanAccess(guide_info.access).some((a) => a === uid || a === `${uid}:M`);
  }

  static myAccessLevel(access, uid) {
    const rank = { Read: 1, Copy: 2, Modify: 3 };
    let level = null;
    Guide.cleanAccess(access).forEach((a) => {
      let found = null;
      if (a === `${uid}:M` || a === "All_M") found = "Modify";
      else if (a === `${uid}:C` || a === "All_C") found = "Copy";
      else if (a === `${uid}:R` || a === "All_R") found = "Read";
      if (found && (!level || rank[found] > rank[level])) level = found;
    });
    return level; // "Read" | "Copy" | "Modify" | null
  }

  // Mine-tab counterpart to myAccessLevel — "what's the highest access I've
  // granted to anyone else on this guide I own" rather than "what access do
  // I have." Returns null when the guide hasn't been shared with anyone
  // (access is empty or only contains the owner's own bare uid entry).
  static sharedOutLevel(access, ownerUid) {
    const rank = { Read: 1, Copy: 2, Modify: 3 };
    let level = null;
    Guide.cleanAccess(access).forEach((a) => {
      if (a === ownerUid) return; // the owner's own bare entry, not a grant to someone else
      let found = null;
      if (a === "All_M" || (a.endsWith(":M") && a.split(":")[0] !== ownerUid)) found = "Modify";
      else if (a === "All_C" || (a.endsWith(":C") && a.split(":")[0] !== ownerUid)) found = "Copy";
      else if (a === "All_R" || (a.endsWith(":R") && a.split(":")[0] !== ownerUid)) found = "Read";
      if (found && (!level || rank[found] > rank[level])) level = found;
    });
    return level; // "Read" | "Copy" | "Modify" | null (not shared)
  }

  // Distinct individually-named recipients (uid:R/C/M entries, excluding the
  // owner's own and excluding blanket All_* grants, which aren't a specific
  // person) — feeds the Mine tab's "To" filter.
  static sharedOutRecipients(access, ownerUid) {
    const uids = new Set();
    Guide.cleanAccess(access).forEach((a) => {
      if (a.includes(":")) {
        const uid = a.split(":")[0];
        if (uid !== ownerUid) uids.add(uid);
      }
    });
    return [...uids];
  }

  accessCategory(access_type, user, owner, guide_info) {
    if (!(access_type in guide_info.categories.keys)) guide_info.categories.keys[access_type] = [];
    guide_info.categories.keys[access_type].push(user);
  }

  getImageURL(img) {
    let photo = Settings.ImageAssets + "/Icons/place.jpg";
    if (img !== "") {
      if (img.indexOf("http:") === -1) photo = Settings.webSite + Settings.ImageLoc + img;
      else photo = img;
    }
    return photo;
  }

  createNewGuide(guide_id, attributes) {
    let guide_obj = new Guide(guide_id);
    guide_obj.attributes = attributes;
    return guide_obj;
  }

  decodeGuide(guideString) {
    //console.log("Original guide size is:", guideString.length);
    var placesTag = "xyxyxPLACESxyxyx";
    var documentTag = "xyxyxJOURNALxyxyx";
    var scheduleTag = "xyxyxSCHEDULExyxyx";
    var placesStart = guideString.indexOf(placesTag);
    var documentStart = guideString.indexOf(documentTag);
    var scheduleStart = guideString.indexOf(scheduleTag);
    if (placesStart == -1 || documentStart == -1 || scheduleStart == -1) {
      this.display_message("Error in guide:" + placesStart + " " + documentStart + " " + scheduleStart);
      return;
    }
    this.places = new Places();
    this.places.decodePlaces(guideString, placesStart, documentStart, placesTag);
    //console.log("decode places");
    //this.journal = new GuideDocument(guideString, documentStart, scheduleStart, documentTag);
    this.document = "";
    //console.log("decode document:");
    this.schedule = new Schedule();
    this.schedule.decodeSchedule(guideString, scheduleStart, scheduleTag, null);
    //this.schedule.updateSchedule();
    //console.log("decode schedule");

    // if (this.places._placesOBJ == null) {
    //console.log("Error in guide places");
    //   return false;
    // }

    // if (this.guide_document._documentOBJ == null) {
    //console.log("Error in guide document");
    //   return false;
    // }

    // if (this.schedule._scheduleOBJ == null) {
    //console.log("Error in guide schedule");
    //   return false;
    // }

    // //console.log("decodeGuide");
    var attributesString = html_entity_decode(guideString.substring(0, placesStart).trim());
    //console.log("AtributeString:" + attributesString);
    window.attributesOBJ = JSON.parse(attributesString);
    if (Array.isArray(window.attributesOBJ)) this.attributes = window.attributesOBJ[0];
    else this.attributes = window.attributesOBJ;

    if (this.attributes.rating == "-1") this.attributes.rating = 0;
    if (typeof this.attributes.rating === "string") this.attributes.rating = parseFloat(this.attributes.rating);
    if (this.attributes.language == "2") this.attributes.language = "English";
    if (typeof this.attributes.countries == "undefined") this.attributes.countries = [];
    if (typeof this.attributes.cities == "undefined") this.attributes.cities = [];
    //if (typeof this.attributes.access == "undefined")
    this.attributes.access = ["All_C"];
    if (typeof this.attributes.image_m == "undefined") this.attributes.image_m = "";
    if (typeof this.attributes.creator_id == "undefined") this.attributes.creator_id = this.attributes.user_id;

    this.attributes.mod = DateTime.now().toISO({ zone: "utc" });
    this.attributes.created = this.attributes.mod;
    this.attributes.read = this.attributes.mod;
    this.attributes.copy = this.attributes.mod;
    this.attributes.num_ratings = 0;
    this.attributes.times_read = 0;
    this.attributes.times_copied = 0;

    // //console.log("decodeGuide", this.attributes);
    //this.categories = this.places.getCategoriesArray();

    this.categories = this.places.getCategoriesArray(_initial_categories);
    this.places.updatePlaceCategories(this.categories);
    this.groups = this.places.getGroupsArray(_initial_groups);
    this.places.updatePlaceGroups(this.groups);

    if (typeof this.attributes.base_location == "undefined") {
      this.attributes.base_location = { latitude: 0, longitude: 0 };
      if (this.places.placesList.length > 0)
        this.attributes.base_location = {
          latitude: parseFloat(this.places.placesList[0].Lat),
          longitude: parseFloat(this.places.placesList[0].Longi),
        };
      else this.attributes.base_location = { latitude: 0, longitude: 0 };
    } else {
      if (this.attributes.base_location.latitude == 0 && this.attributes.base_location.longitude == 0)
        if (this.places.placesList.length > 0)
          this.attributes.base_location = {
            latitude: parseFloat(this.places.placesList[0].Lat),
            longitude: parseFloat(this.places.placesList[0].Longi),
          };
    }
    return true;
  }

  decodeGuideFb(GuideJson, guideAttributes) {
    this.places = new Places();
    this.places.decodePlaces(null, null, null, null, GuideJson);
    this.schedule = new Schedule();
    this.schedule.decodeSchedule(null, null, null, GuideJson);

    //var attributesString = html_entity_decode(guideString.substring(0, placesStart).trim());

    let _attributes = {};
    this.attributes = new GuideAttributes("New", "New Guide", "", "English", 0, [], []);
    if (guideAttributes == null) {
      if (Array.isArray(GuideJson.attributes)) _attributes = GuideJson.attributes[0];
      else _attributes = GuideJson.attributes;
    } else _attributes = guideAttributes;
    this.attributes.decodeAttributes(_attributes);
    this.attributes.guide_id = this.guide_id;

    //console.log("decodeGuideFb", this.attributes);
    delete this.attributes.name;
    delete this.attributes.shared;
    delete this.attributes.share_all;
    delete this.attributes.group_read;
    delete this.attributes.group_copy;
    delete this.attributes.group_modify;

    this.groups = GuideJson.groups || [];
    if (this.groups.length > 0) {
      //console.log("typeof this.groups[0]", typeof this.groups[0]);
      if (typeof this.groups[0] == "string") {
        this.groups = this.places.getGroupsArray(_initial_groups);
        this.places.updatePlaceGroups(this.groups);
      }
    }

    // Ensure new fields exist on every group object
    for (let g = 0; g < this.groups.length; g++) {
      if (typeof this.groups[g].schedule === "undefined") this.groups[g].schedule = "";
      if (typeof this.groups[g].mosaic   === "undefined") this.groups[g].mosaic   = false;
      if (typeof this.groups[g].image    === "undefined") this.groups[g].image    = "";
    }

    // Backwards compat: if a group named "X_m" exists AND a schedule named "X" exists,
    // migrate by setting schedule="X" and mosaic=true on that group.
    const scheduleNames = this.schedule.geScheduleNames().map(s => s.label);
    for (let g = 0; g < this.groups.length; g++) {
      const grp = this.groups[g];
      if (grp.schedule !== "" || !grp.name.endsWith("_m")) continue;
      const baseName = grp.name.slice(0, -2);
      if (scheduleNames.includes(baseName)) {
        grp.schedule = baseName;
        grp.mosaic   = true;
      }
    }

    // One-time migration: "Bucket List" used to be a magic-named group
    // ("Bucket List_m") rather than a real Place attribute. This no longer
    // creates that group for guides that never had one — it only reads
    // membership from a guide that already has it (from before this change)
    // and sets place.BucketList = true for those places. The group itself is
    // left untouched (vestigial, harmless) rather than deleted.
    const bucket_group = this.findGroupFromName("Bucket List_m");
    if (bucket_group !== null) {
      for (let p = 0; p < this.places.placesList.length; p++) {
        const place = this.places.placesList[p];
        if (place.contains_Group(bucket_group.id) && place.BucketList !== true) {
          place.BucketList = true;
        }
      }
    }

    this.categories = GuideJson.categories || [];
    if (this.categories.length > 0) {
      if (typeof this.categories[0] == "string") {
        this.categories = this.places.getCategoriesArray(_initial_categories);
        this.places.updatePlaceCategories(this.categories);
        //console.log("this.categories", this.categories);
      }
    }
    this.chapters = GuideJson.chapters || [];
    // dateStart/dateEnd round-trip as plain ISO strings through Firestore
    // (Luxon's DateTime.toJSON() on encode) — convert back to DateTime here,
    // same {zone:"utc"} convention as mod/created/read/copy above.
    this.destinations = (GuideJson.destinations || []).map((d) => ({
      ...d,
      dateStart: DateTime.fromISO(d.dateStart, { zone: "utc" }),
      dateEnd: DateTime.fromISO(d.dateEnd, { zone: "utc" }),
    }));
    this.aiPreferences = GuideJson.aiPreferences || null;
    this.photoBookLayout = GuideJson.photoBookLayout || null;
    this.flights = GuideJson.flights || [];
    this.tripMembers = GuideJson.tripMembers || [];
    this.expenses = GuideJson.expenses || [];
    //create default Notes

    this.createNote();

    // let section = this.findSectionByName("My notes", "Notes1")
    // if(section === null){
    //   let chapter = this.findChapterByName("My notes");
    //   if(chapter === null)
    //     chapter = this.addChapter("My notes");
    //   section = this.findSectionByName("My notes", "Notes1")
    //   if(section === null)
    //   {
    //     section = new Section(this.chapters, "Notes1");
    //     if(section !== null){
    //       section.Title = "Notes1";
    //       section.html = "";
    //       let index = this.addSection(chapter.ID, section)
    //       console.log("section index", index);
    //     }
    //   }
    // }

    if (this.attributes.rating == "-1") this.attributes.rating = 0;
    if (this.attributes.language == "2") this.attributes.language = "English";
    if (typeof this.attributes.countries == "undefined") this.attributes.countries = [];
    if (typeof this.attributes.cities == "undefined") this.attributes.cities = [];
    //if (typeof GuideJson.journal != "undefined") this.journal = GuideJson.journal;
    if (typeof GuideJson.document != "undefined") this.document = GuideJson.document;
    if (typeof this.attributes.image_m == "undefined") this.attributes.image_m = "";
    if (typeof this.attributes.creator_id == "undefined") this.attributes.creator_id = this.attributes.user_id;
    if (typeof GuideJson.guide_settings != "undefined") this.guide_settings = GuideJson.guide_settings;

    if (typeof this.attributes.base_location == "undefined") {
      if (this.places.placesList.length > 0)
        this.attributes.base_location = {
          latitude: parseFloat(this.places.placesList[0].Lat),
          longitude: parseFloat(this.places.placesList[0].Longi),
        };
      else this.attributes.base_location = { latitude: 0, longitude: 0 };
    } else {
      if (this.attributes.base_location.latitude == 0 && this.attributes.base_location.longitude == 0)
        if (this.places.placesList.length > 0)
          this.attributes.base_location = {
            latitude: parseFloat(this.places.placesList[0].Lat),
            longitude: parseFloat(this.places.placesList[0].Longi),
          };
    }
    if (typeof GuideJson.custom_icons != "undefined") this.custom_icons = GuideJson.custom_icons;
    if (typeof GuideJson.guide_settings === "undefined") {
      this.guide_settings = JSON.parse(JSON.stringify(GuideSettings));
    } else {
      if (this.guide_settings.places_list && typeof this.guide_settings.places_list.path_link === "undefined")
        this.guide_settings.places_list.path_link = false;
      if (this.guide_settings.places_map && typeof this.guide_settings.places_map.path_link === "undefined")
        this.guide_settings.places_map.path_link = false;
      if (this.guide_settings.places_map && typeof this.guide_settings.places_map.number === "undefined") this.guide_settings.places_map.number = true;
      if (typeof GuideJson.guide_settings.itinerary === "undefined")
        this.guide_settings.itinerary = {
          directions: true,
          info: true,
          photo: false,
          place_menu: true,
        };
      if (typeof GuideJson.guide_settings.places_map_hover === "undefined")
        this.guide_settings.places_map_hover = {
          menu: false,
          place: true,
          info: true,
          event: true,
        };
    }
    // this.places.placesList.forEach((p) => {
    //   p.Info = "";
    //   p.URL = "";
    //   p.Hlink = "";
    // });
    return true;
  }

  // display_message(msg) {
  //   Alert.alert(
  //     "Message",
  //     msg,
  //     [
  //       {
  //         text: "OK",
  //         style: "cancel",
  //       },
  //     ],
  //     { cancelable: false }
  //   );
  // }
  downloadGuide() {
    //console.log(JSON.stringify({ guide_id: this.guide_id }));

    var request = new XMLHttpRequest();
    request.onreadystatechange = (e) => {
      if (request.readyState !== 4) {
        return;
      }

      if (request.status === 200) {
        if (request.responseText != null) {
          //console.log("Guide downloaded");
          this.decodeGuide(request.responseText);
          this.schedule.getPlaces_InSchedule();
        }
      } else {
        //console.warn("error downloading guide");
      }
    };

    request.open("GET", `http://www.liquidguides.com/database/download_GuideSections.php?guide_id=${this.guide_id}`);
    request.send();
  }

  createNote() {
    let section = this.findSectionByName("My notes", "Notes1")
    if(section === null){
      let chapter = this.findChapterByName("My notes");
      if(chapter === null)
        chapter = this.addChapter("My notes");
      section = this.findSectionByName("My notes", "Notes1")
      if(section === null)
      {
        section = new Section(this.chapters, "Notes1");
        if(section !== null){
          section.Title = "Notes1";
          section.html = "";
          let index = this.addSection(chapter.ID, section)
          console.log("section index", index);
        }
      }
    }
  }

  addCategoryOLD(category) {
    this.categories.push(category);
  }

  addCategory(category_name) {
    const new_category = new Category(this.categories, category_name);
    this.categories.push(new_category);
    return new_category.id;
  }

  modifyCategory(oldCategory, newCategory) {
    let index = this.categories.findIndex((x) => x.id == oldCategory.id);
    if (index != -1) {
      this.categories[index].name = newCategory.name;
      this.categories[index].poi_img = newCategory.poi_img;
    }
  }

  deleteCategory(category) {
    //console.log("deleteCategory", category);
    const index = this.categories.findIndex((x) => x.id == category.id);
    //console.log("deleteCategory index:", index);
    if (index == -1) return;
    this.categories.splice(index, 1);
    this.places.deletePlaceCategory(category.id);
  }

  categoryFromID(categoryID) {
    let index = this.categories.findIndex((x) => x.id == categoryID);
    if (index != -1) return this.categories[index];
    index = _initial_categories.findIndex((x) => x.id == categoryID);
    if (index != -1) return _initial_categories[index];
    return null;
  }

  categoryNameFromID(categoryID) {
    let index = this.categories.findIndex((x) => x.id == categoryID);
    if (index != -1) return this.categories[index].name;
    index = _initial_categories.findIndex((x) => x.id == categoryID);
    if (index != -1) return _initial_categories[index].name;
    return "No Category";
  }

  categoryNamesFromIDs(categoryIDs, sep) {
    //console.log("categoryNamesFromIDs", categoryIDs);
    if (!Array.isArray(categoryIDs)) categoryIDs = [categoryIDs];
    let names = "";
    if (sep == null) sep = ";";
    categoryIDs.forEach((id) => {
      let name = "NA";
      let index = this.categories.findIndex((x) => x.id == id);
      if (index !== -1) name = this.categories[index].name;
      else {
        index = _initial_categories.findIndex((x) => x.id == id);
        if (index !== -1) name = _initial_categories[index].name;
      }
      names += names === "" ? name : `${sep} ${name}`;
    });
    return names;
  }

  categoryObjectArrayFromIDArray(categoryIDs) {
    if (!Array.isArray(categoryIDs)) categoryIDs = [categoryIDs];
    let category_array = [];
    categoryIDs.forEach((id) => {
      let index = this.categories.findIndex((x) => x.id == id);
      if (index !== -1) category_array.push(this.categories[index]);
      else {
        index = _initial_categories.findIndex((x) => x.id == id);
        if (index !== -1) category_array.push(_initial_categories[index]);
      }
    });
    return category_array;
  }

  groupFromID(groupID) {
    let index = this.groups.findIndex((x) => x.id == groupID);
    if (index != -1) {
      //if (groupID == "13") //console.log(this.groups[index]);
      return this.groups[index];
    }
    return null;
  }

  findGroupFromName(group_name) {
    let index = this.groups.findIndex((x) => x.name == group_name);
    if (index != -1) {
      //if (groupID == "13") //console.log(this.groups[index]);
      return this.groups[index];
    }
    return null;
  }

  groupNameFromID(groupID) {
    let index = this.groups.findIndex((x) => x.id == groupID);
    if (index != -1) return this.groups[index].name;
    return "No Group";
  }

  groupNameArrayFromIDArray(groupIDs) {
    if (!Array.isArray(groupIDs)) groupIDs = [groupIDs];
    let names = [];
    groupIDs.forEach((id) => {
      let name = "NA";
      let index = this.groups.findIndex((x) => x.id == id);
      if (index != -1) names.push(this.groups[index].name);
    });
    return names;
  }

  groupObjectArrayFromIDArray(groupIDs) {
    if (!Array.isArray(groupIDs)) groupIDs = [groupIDs];
    let group_array = [];
    groupIDs.forEach((id) => {
      let name = "NA";
      let index = this.groups.findIndex((x) => x.id == id);
      if (index != -1) group_array.push(this.groups[index]);
    });
    return group_array;
  }

  groupNamesFromIDs(groupIDs, sep) {
    if (!Array.isArray(groupIDs)) groupIDs = [groupIDs];
    //console.log("groupIDs", groupIDs);
    let names = "";
    if (sep == null) sep = ";";
    groupIDs.forEach((id) => {
      let name = "NA";
      let index = this.groups.findIndex((x) => x.id == id);
      if (index != -1) name = this.groups[index].name;
      names += names == "" ? name : `${sep} ${name}`;
    });
    return names;
  }

  addGroup(group_name) {
    const group = new Group(this.groups, group_name);
    //console.log(group, group_name);
    this.groups.push(group);
    return(group.id);
  }

  modifyGroup(oldGroup, newGroup) {
    let index = this.groups.findIndex((x) => x.id == oldGroup.id);
    if (index != -1) {
      this.groups[index].name = newGroup.name;
      this.groups[index].poi_img = newGroup.poi_img;
      if (newGroup.url !== undefined) this.groups[index].url = newGroup.url;
      if (newGroup.mosaic !== undefined) this.groups[index].mosaic = newGroup.mosaic;
      if (newGroup.schedule !== undefined) this.groups[index].schedule = newGroup.schedule;
      if (newGroup.image !== undefined) this.groups[index].image = newGroup.image;
    }
  }

  deleteGroup(group) {
    //console.log("deleteGroup", group);
    const index = this.groups.findIndex((x) => x.id == group.id);
    if (index == -1) return;
    this.groups.splice(index, 1);
    //console.log("deleteGroup index", index);
    this.places.deletePlaceGroup(group.id);
  }

  addChapter(chapter_title) {
    let new_chapter = new Chapter(this.chapters, chapter_title);
    this.chapters.push(new_chapter);
    return new_chapter;
  }

  modifyChapter(old_chapter, new_chapter_name) {
    //console.log("modifyChapter", old_chapter);
    const index = this.chapters.findIndex((x) => x.ID == old_chapter.ID);
    //console.log("modifyChapter", index);
    if (index == -1) return;
    this.chapters[index].Title = new_chapter_name;
  }

  replaceChapters(chapters) {
    let newChapters = [];
    chapters.forEach((chapter) => {
      newChapters.push(chapter.value);
    });
    // //console.log("newChapters", newChapters);
    this.chapters = newChapters;
  }

  deleteChapter(chapter_id) {
    // //console.log("deleteChapter", chapter_id);
    const index = this.chapters.findIndex((x) => x.ID == chapter_id);
    // //console.log("deleteChapter2", index);
    if (index == -1) return;
    this.chapters.splice(index, 1);
  }

  findChapterByName(chapter_name) {
    const index = this.chapters.findIndex((x) => x.Title == chapter_name);
    if (index == -1) return null;
    return this.chapters[index];
  }

  findSectionByName(chapter_name, section_name) {
    const index = this.chapters.findIndex((x) => x.Title == chapter_name);
    if (index == -1) return null;
    const index2 = this.chapters[index].sections.findIndex((x) => x.Title == section_name);
    if (index2 == -1) return null;
    return this.chapters[index].sections[index2];
  }

  addSection(chapter_id, section) {
    //console.log("addSection", chapter_id, section);
    const index = this.chapters.findIndex((x) => x.ID == chapter_id);
    if (index === -1) {
      //console.log("addSection: Chapter not found", chapter_id, section);
      return -1;
    }
    this.chapters[index].sections.push(section);
    return(index);
    //console.log("addSection: Section added", chapter_id, section);
    //console.log("Added section", this.chapters[index].sections[this.chapters[index].sections.length - 1]);
  }

  modifySection(chapter_id, oldSection, newSection) {
    //console.log("oldSection", oldSection, "newSection", newSection);
    const index = this.chapters.findIndex((x) => x.ID == chapter_id);
    if (index == -1) return;
    //console.log("Found chapter");
    const index2 = this.chapters[index].sections.findIndex((x) => x.ID == oldSection.ID);
    if (index2 == -1) return;
    //console.log("Found section");
    this.chapters[index].sections[index2].Title = newSection.Title;
    this.chapters[index].sections[index2].PlaceIds = newSection.PlaceIds;
    this.chapters[index].sections[index2].Groups = newSection.Groups;
    this.chapters[index].sections[index2].Categories = newSection.Categories;
    this.chapters[index].sections[index2].Info = newSection.Info;
    this.chapters[index].sections[index2].html = newSection.html;
    //console.log("modifySection", this.chapters[index].sections[index2]);
  }

  replaceSections(chapter_id, sections) {
    // //console.log("Add section", chapter_id, section);
    const index = this.chapters.findIndex((x) => x.ID == chapter_id);
    if (index == -1) return;
    let newSections = [];
    sections.forEach((section) => {
      newSections.push(section.value);
    });
    // //console.log("newSections", newSections);
    this.chapters[index].sections = newSections;
    // //console.log("Added section", this.chapters[index].sections[this.chapters[index].sections.length - 1]);
  }

  deleteSection(chapter_id, section) {
    const index = this.chapters.findIndex((x) => x.ID == chapter_id);
    if (index == -1) return;
    const index2 = this.chapters[index].sections.findIndex((x) => x.ID == section.ID);
    // //console.log("deleteSection", index);
    if (index2 == -1) return;
    this.chapters[index].sections.splice(index2, 1);
  }

  findSection(section_id) {
    //console.log("findSection", this.chapters);
    //console.log("section_id", section_id);
    for (let i = 0; i < this.chapters.length; i++) {
      for (let j = 0; j < this.chapters[i].sections.length; j++) {
        if (this.chapters[i].sections[j].ID == section_id) return this.chapters[i].sections[j];
      }
    }
    // this.chapters.forEach((chapter) => {
    //   chapter.forEach((section) => {
    //     if ((section.ID = section_id)) return section;
    //   });
    // });
    return null;
  }

  getDocumentHTML() {
    if (typeof this.document == "undefined" || this.document == "") return this.createGuideHTML();
      return this.document;
  }
  // findSection(chapter_id, section_name) {
  //   const index = this.chapters.findIndex((x) => x.ID == chapter_id);
  //   if (index == -1) return null;
  //   const index2 = this.chapters[index].sections.findIndex((x) => x.Title == section_name);
  //   // //console.log("deleteSection", index);
  //   if (index2 == -1) return null;
  //   return this.chapters[index].sections[index2];
  // }

  getAllGroupsToDisplay() {
    let groupsArray = this.groups;
    let groupsList = [];
    if (groupsArray.length > 0) {
      if (typeof groupsArray[0] != "string") {
        for (let i = 0; i < groupsArray.length; i++) {
          groupsList.push({
            id: groupsArray[i].id,
            name: groupsArray[i].name,
            label: groupsArray[i].name,
            icon: groupsArray[i].poi_img,
            value: groupsArray[i],
          });
        }
        groupsList = groupsList.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
      } else {
        groupsArray = Array.from(new Set(groupsArray)).sort();
        for (let i = 0; i < groupsArray.length; i++) {
          groupsList.push({
            id: i.toString(),
            name: groupsArray[i],
            label: groupsArray[i],
            value: groupsArray[i],
          });
        }
      }
    }
    //console.log("getAllGroupsToDisplay:", groupsList);
    return groupsList;
  }

  getGroupsToDisplay(filteredPlacesList, used) {
    let groupsIDArray = [];
    if (filteredPlacesList == null && used != true) {
      return this.getAllGroupsToDisplay();
    }
    //console.log("this.places.placesList", this.places.placesList);
    if (filteredPlacesList == null && used == true) filteredPlacesList = this.places.placesList;
    let id = 0;
    //console.log("this.placesList", this.placesList);
    for (let i = 0; i < filteredPlacesList.length; i++) {
      for (var j = 0; j < filteredPlacesList[i].Group.length; j++) {
        if (!groupsIDArray.includes(filteredPlacesList[i].Group[j])) groupsIDArray.push(filteredPlacesList[i].Group[j]);
      }
    }

    //console.log("groupsIDArray", groupsIDArray);
    groupsIDArray = Array.from(new Set(groupsIDArray));
    //console.log("groupsIDArray", groupsIDArray);
    let groupsObjArray = this.groupObjectArrayFromIDArray(groupsIDArray);
    //console.log("groupsObjArray", groupsObjArray);
    let groupsList = [];
    for (let i = 0; i < groupsObjArray.length; i++) {
      groupsList.push({
        id: groupsObjArray[i].id,
        name: groupsObjArray[i].name,
        label: groupsObjArray[i].name,
        icon: groupsObjArray[i].poi_img,
        value: groupsObjArray[i],
      });
    }
    groupsList = groupsList.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
    //console.log("getGroupsToDisplay:", groupsList);
    return groupsList;
  }

  getAllCategoriesToDisplay() {
    let categoriesArray = this.categories;
    //console.log("getAllCategoriesToDisplay", categoriesArray);
    let categoriesList = [];
    if (categoriesArray.length > 0) {
      //console.log("categoriesArray[0]", categoriesArray[0]);
      if (typeof categoriesArray[0] != "string") {
        for (let i = 0; i < categoriesArray.length; i++) {
          categoriesList.push({
            id: categoriesArray[i].id,
            name: categoriesArray[i].name,
            label: categoriesArray[i].name,
            icon: categoriesArray[i].poi_img,
            value: categoriesArray[i],
          });
        }
        categoriesList = categoriesList.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
      } else {
        categoriesArray = Array.from(new Set(categoriesArray)).sort();
        for (let i = 0; i < categoriesArray.length; i++) {
          categoriesList.push({
            id: i.toString(),
            name: categoriesArray[i],
            label: categoriesArray[i],
            value: categoriesArray[i],
          });
        }
      }
    }
    //console.log("getAllGroupsToDisplay:", categoriesList);
    return categoriesList;
  }

  getCategoriesToDisplay(filteredPlacesList, used) {
    let categoriesIDArray = [];
    if (filteredPlacesList == null && used !== true) {
      return this.getAllCategoriesToDisplay();
    }
    //console.log("this.places.placesList", this.places.placesList);
    if (filteredPlacesList == null && used === true) filteredPlacesList = this.places.placesList;
    //console.log("this.placesList", this.placesList);
    for (let i = 0; i < filteredPlacesList.length; i++) {
      for (var j = 0; j < filteredPlacesList[i].Category.length; j++) {
        //if (!categoriesIDArray.includes(filteredPlacesList[i].Category[j]))
        categoriesIDArray.push(filteredPlacesList[i].Category[j]);
      }
    }

    //console.log("categoriesIDArray", categoriesIDArray);
    categoriesIDArray = Array.from(new Set(categoriesIDArray));
    //console.log("categoriesIDArray", categoriesIDArray);
    let categoriesObjArray = this.categoryObjectArrayFromIDArray(categoriesIDArray);
    //console.log("categoriesObjArray", categoriesObjArray);
    let categoriesList = [];
    for (let i = 0; i < categoriesObjArray.length; i++) {
      categoriesList.push({
        id: categoriesObjArray[i].id,
        name: categoriesObjArray[i].name,
        label: categoriesObjArray[i].name,
        icon: categoriesObjArray[i].poi_img,
        value: categoriesObjArray[i],
      });
    }
    categoriesList = categoriesList.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1));
    //console.log("getCategoriesToDisplay:", categoriesList);
    return categoriesList;
  }

  getCategoriesToDisplayOLD(filteredPlacesList, used) {
    let categoriesArray = [];
    if (filteredPlacesList == null && used !== true) {
      categoriesArray = this.categories;
    } else {
      if (used === true) filteredPlacesList = this.places.placesList;
      for (let i = 0; i < filteredPlacesList.length; i++) {
        if (filteredPlacesList[i] == null) continue;
        var cats = filteredPlacesList[i].getCategories();
        for (var j = 0; j < cats.length; ++j) {
          if (cats[j] === "HTML_CONTENT") continue;
          categoriesArray.push(cats[j]);
        }
      }
    }
    categoriesArray.push("New");
    categoriesArray = Array.from(new Set(categoriesArray)).sort();
    let categoriesList = [];
    let id = 1;
    for (let i = 0; i < categoriesArray.length; i++) {
      categoriesList.push({
        id: (id++).toString(),
        name: categoriesArray[i],
        label: categoriesArray[i],
        value: categoriesArray[i],
      });
    }
    //console.log("categoriesList:", categoriesList);
    return categoriesList;
  }

  getChaptersToDisplay() {
    let chaptersList = [];
    let id = 0;
    for (let i = 0; i < this.chapters.length; i++) {
      chaptersList.push({
        id: (id++).toString(),
        name: this.chapters[i].Title,
        label: this.chapters[i].Title,
        value: this.chapters[i],
      });
    }
    //chaptersList.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
    return chaptersList;
  }

  getSectionsToDisplay(chapter_id) {
    // //console.log("getSectionsToDisplay: chapter_id", chapter_id);
    const index = this.chapters.findIndex((x) => x.ID === chapter_id);
    if (index === -1) return [];
    // //console.log("getSectionsToDisplay", this.chapters[index].sections);
    let sectionsList = [];
    let id = 0;
    for (let i = 0; i < this.chapters[index].sections.length; i++) {
      sectionsList.push({
        id: (id++).toString(),
        name: this.chapters[index].sections[i].Title,
        label: this.chapters[index].sections[i].Title,
        value: this.chapters[index].sections[i],
      });
    }
    //sectionsList.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
    return sectionsList;
  }

  getChaptersSectionsToDisplay() {
    let sections = [];
    // //console.log(this.chapters);
    for (let j = 0; j < this.chapters.length; j++) {
      let section = { Title: this.chapters[j].Title, ID: this.chapters[j].ID, data: [], index: j + 1 };
      for (let i = 0; i < this.chapters[j].sections.length; i++) {
        let _sec = this.chapters[j].sections[i];
        _sec.Chapter = this.chapters[j].Title;
        _sec.ChapterID = this.chapters[j].ID;
        section.data.push(_sec);
      }
      sections.push(section);
    }
    // //console.log(sections);
    return sections;
  }

  getGroupAndCategoryPlaces(PlaceIds, GroupIDs, CategoryIDs) {
    //console.log(section);
    //console.log("getGroupAndCategoryPlaces", PlaceIds, GroupIDs, CategoryIDs);
    let places = this.places.getPlacesFromIDs(PlaceIds);
    if (GroupIDs.length === 0 && CategoryIDs.length === 0) return places;
    //console.log("getGroupAndCategoryPlaces 1");
    if (GroupIDs.length !== 0 && CategoryIDs.length === 0) {
      //console.log("getGroupAndCategoryPlaces 2");
      for (let i = 0; i < this.places.placesList.length; i++) {
        var place_groups = this.places.placesList[i].getGroups();
        for (let x = 0; x < GroupIDs.length; x++) {
          if (place_groups.includes(GroupIDs[x])) {
            //console.log("getGroupAndCategoryPlaces 3");
            if (!places.includes(this.places.placesList[i])) {
              //console.log("getGroupAndCategoryPlaces 4");
              places.push(this.places.placesList[i]);
              break;
            }
          }
        }
      }
      places = Array.from(new Set(places));
      return places;
    }
    if (GroupIDs.length === 0 && CategoryIDs.length !== 0) {
      for (let i = 0; i < this.places.placesList.length; i++) {
        var place_cats = this.places.placesList[i].getCategories();
        for (let y = 0; y < CategoryIDs.length; y++)
          if (place_cats.includes(CategoryIDs[y])) {
            if (!places.includes(this.places.placesList[i])) {
              // //console.log("place_cats", place_cats);
              places.push(this.places.placesList[i]);
              break;
            }
          }
      }
      places = Array.from(new Set(places));
      return places;
    }
    if (GroupIDs.length !== 0 && CategoryIDs.length !== 0) {
      for (let i = 0; i < this.places.placesList.length; i++) {
        var place_groups = this.places.placesList[i].getGroups();
        for (let x = 0; x < GroupIDs.length; x++) {
          if (place_groups.includes(GroupIDs[x])) {
            var place_cats = this.places.placesList[i].getCategories();
            for (let y = 0; y < CategoryIDs.length; y++)
              if (place_cats.includes(CategoryIDs[y])) {
                if (!places.includes(this.places.placesList[i])) {
                  places.push(this.places.placesList[i]);
                  break;
                }
              }
          }
        }
      }
      places = Array.from(new Set(places));
      return places;
    }
  }

  createMapHtml(placeIDs, GroupIDs, CategoryIDs, list) {
    //console.log("createMapHtml", placeIDs, GroupIDs, CategoryIDs);
    let places = this.getGroupAndCategoryPlaces(placeIDs, GroupIDs, CategoryIDs); //this.places.getPlacesFromIDs(placeIDs);
    let places_string = "";
    //console.log("createMapHtml", places);
    let html_doc = "";
    let path = "";
    let markers = "";
    // //console.log("places.length", places.length);
    let _index = 0;
    for (let m = 0; m < places.length; m++) {
      places_string += places_string == "" ? places[m].ID : "," + places[m].ID;
      let _path = places[m].getPath();
      if (_path == null) {
        if (markers == "")
          markers = `&markers=size:mid%7Ccolor:red%7Clabel:${labelChars[_index]}%7C${places[m].Lat},${places[m].Longi}`;
        else
          markers += `|&markers=size:mid%7Ccolor:red%7Clabel:${labelChars[_index]}%7C${places[m].Lat},${places[m].Longi}`;
        _index += 1;
      } else {
        if (places[m].PType == "Polygon") {
          const points = _path.split("|");
          if (points.length > 2) {
            if (points[1] != points[points.length - 1]) _path += "|" + points[1];
          }
        }
        let path_type = `&path=color:0xff0000ff|weight:2`;
        if (places[m].PType == "Polygon") path_type = "&path=fillcolor:0x0000FF33%7Ccolor:0x0000ff33%|weight:2";
        if (path == "") path = `${path_type}${_path}`;
        else path += `|${_path}`;
      }
    }
    places_string += "||";
    let static_map = `https://maps.googleapis.com/maps/api/staticmap?size=400x300&scale=2&maptype=roadmap${markers}${path}&key=${process.env.REACT_APP_GOOGLE_MAPS_STATIC_API}`;

    if (path != "" || markers != "")
      //html_doc += `<img src="${static_map}" alt="Map" width="500" height="400"></img><br/><br/>`;
      html_doc = `<p style="text-align:center;"><a href="maplink:${places_string}||"><img src="${static_map}" alt="Image" style="width:100%; max-width:700px; height:auto; border-radius:10%" onerror="window.imgFallback(this)"></img></a></p>`;
    if (list == true) {
      for (let j = 0; j < places.length; j++) {
        if (places[j].PType != "Icon") html_doc += `<a href="placemenulink:${places[j].ID}">${places[j].Name}</a><br>`;
      }
      let _index = 0;
      for (let j = 0; j < places.length; j++) {
        if (places[j].PType == "Icon") {
          html_doc += `<a href="placemenulink:${places[j].ID}">${labelChars[_index]}. ${places[j].Name}</a><br>`;
          _index += 1;
        }
      }
    }
    return html_doc;
  }

  getPlacesListHTML(placeIDs, GroupIDs, CategoryIDs) {
    //let places = this.places.getPlacesFromIDs(placeIDs);
    let places = this.getGroupAndCategoryPlaces(placeIDs, GroupIDs, CategoryIDs);
    let html_doc = "<ol>";
    for (let i = 0; i < places.length; i++) {
      html_doc += `<li>${places[i].Name}</li>`;
    }
    html_doc += "</ol>";
    return html_doc;
  }

  getsectionHTML(section) {
    //const _places = this.places.getPlacesFromIDs(section.PlaceIds);
    const places = this.getGroupAndCategoryPlaces(section);
    let html_doc = "";
    let day = -1;
    html_doc += `<p><h3>${section.Title}</h3></p>`;
    html_doc += `<p>${section.Info}</p>`;
    let label = 1;
    let path = "";
    let markers = "";
    let places_string = "";
    // //console.log("places.length", places.length);
    for (let m = 0; m < places.length; m++) {
      places_string += places_string == "" ? places[m].ID : "," + places[m].ID;
      let _path = places[m].getPath();
      if (_path == null) {
        if (markers == "")
          markers = `&markers=size:mid%7Ccolor:red%7Clabel:${label.toString()}%7C${places[m].Lat},${places[m].Longi}`;
        else
          markers += `|&markers=size:mid%7Ccolor:red%7Clabel:${label.toString()}%7C${places[m].Lat},${places[m].Longi}`;
        label += 1;
      } else {
        if (places[m].PType == "Polygon") {
          const points = _path.split("|");
          if (points.length > 2) {
            if (points[1] != points[points.length - 1]) _path += "|" + points[1];
          }
        }
        let path_type = `&path=color:0xff0000ff|weight:2`;
        if (places[m].PType == "Polygon") path_type = "&path=fillcolor:0x0000FF33%7Ccolor:0x0000ff33%|weight:2";
        if (path == "") path = `${path_type}${_path}`;
        else path += `|${_path}`;
      }
    }
    places_string += "||";
    let static_map = `https://maps.googleapis.com/maps/api/staticmap?size=400x300&scale=2&maptype=roadmap${markers}${path}&key=${process.env.REACT_APP_GOOGLE_MAPS_STATIC_API}`;

    if (path != "" || markers != "")
      html_doc += `<a href="maplink:${places_string}||"><img src="${static_map}" alt="Map" style="width:100%; max-width:700px; height:auto; border-radius:10%" onerror="window.imgFallback(this)"></img></a><br/><br/>`;
    html_doc += "<ol>";
    for (let j = 0; j < places.length; j++) {
      if (places[j].PType != "Icon") html_doc += `<a href="placemenulink:${places[j].ID}">${places[j].Name}</a><br>`;
    }
    let _index = 0;
    for (let j = 0; j < places.length; j++) {
      if (places[j].PType == "Icon") {
        html_doc += `<a href="placemenulink:${places[j].ID}">${labelChars[_index]}. ${places[j].Name}${
          places[j].MustSee == true ? "*" : ""
        }</a><br>`;
        _index += 1;
      }
    }

    html_doc += "</ol>";
    html_doc += "</p>";
    //</body></html>`;
    //console.log(html_doc);
    return html_doc;
  }

  isAuthorized(auth, action) {
    if (auth >= action) return true;
    else return false;
    // //console.log(auth, action);
    // if (action == AUTHORIZATION_LEVEL.COPY || action == AUTHORIZATION_LEVEL.MODIFY)
    //   if (auth.includes("Update") || auth.includes("Copy")) return true;
    //   else return false;
    // if (action == "Save")
    //   if (auth.includes("Update")) return true;
    //   else return false;
    // return false;
  }

  getChooseDatesList(ScheduleName) {
    if (ScheduleName == null) ScheduleName = "Main";
    let dates = [];
    let day = -1;
    let id = 1;
    for (let i = 0; i < this.schedule.events.length; i++) {
      const event = this.schedule.events[i];
      if (event.Itinerary != ScheduleName) continue;
      // event.Start is a UTC ISO string meaning local wall-clock time — bucket
      // it in UTC, not the device's local zone (see no-timezone convention).
      const luxonDate = DateTime.fromISO(event.Start, { zone: "utc" });
      const dateTime = luxonDate.startOf("day").toMillis();
      if (day != luxonDate.weekday % 7) {
        day = luxonDate.weekday % 7;
        const day_string = `${Settings.DAYS[luxonDate.weekday % 7]}, ${
          Settings.MONTHS[luxonDate.month - 1]
        }, ${luxonDate.day}, ${luxonDate.year}`;
        dates.push({
          label: day_string,
          value: dateTime,
          id: (id++).toString(),
        });
      }
    }
    return dates;
  }

  getAllScheduledPlaces(ScheduleName, dateTime) {
    if (ScheduleName == null) ScheduleName = "Main";
    let scheduledPlaces = [];
    for (let i = 0; i < this.schedule.events.length; i++) {
      const event = this.schedule.events[i];
      if (event.Itinerary != ScheduleName) continue;
      if (typeof dateTime != "undefined" && dateTime != null) {
        // event.Start is stored as a UTC ISO string but means local wall-clock time
        // (see the app's no-real-timezone convention) — zero it to UTC midnight, not
        // the device's local midnight, or the day boundary shifts with device tz.
        const eventDateTime = DateTime.fromISO(event.Start, { zone: "utc" }).startOf("day").toMillis();
        if (eventDateTime != dateTime) continue;
      }
      //console.log(dateTime);
      const places = event.get_places(this.places);
      for (let k = 0; k < places.length; k++) {
        let placeIncluded = scheduledPlaces.find((x) => x.ID == places[k].ID);
        if (!placeIncluded) {
          //place_copy = JSON.parse(JSON.stringify(places[k]));
          places[k].scheduled = [];
          scheduledPlaces.push(places[k]);
        }
        places[k].scheduled.push({ start: event.Start, end: event.End });
      }
    }
    return scheduledPlaces;
  }

  getPlaceSchedule(place) {
    let start_time = null;
    for (let i = 0; i < this.schedule.events.length; i++) {
      const event = this.schedule.events[i];
      const places = event.get_places(this.places);
      for (let k = 0; k < places.length; k++) {
        if (place.ID == places[k].ID) {
          return event.Start;
        }
      }
    }
    return start_time;
  }
  getPlacesinSchedule(dates, scheduleName) {
    //console.log("dates", dates, "scheduleName", scheduleName);
    let placesInSchedule = [];
    for (let i = 0; i < this.schedule.events.length; i++) {
      const event = this.schedule.events[i];
      // event.Start/End are UTC ISO strings meaning local wall-clock time — bucket
      // in UTC, not the device's local zone (see no-timezone convention).
      let luxonStart = DateTime.fromISO(event.Start, { zone: "utc" });
      let dateStartTxt = `${luxonStart.day}-${luxonStart.month - 1}-${luxonStart.year}`;
      let dateStartTime = luxonStart.startOf("day").toMillis();
      let dateEndTime = DateTime.fromISO(event.End, { zone: "utc" }).startOf("day").toMillis();
      for (let j = 0; j < dates.length; j++) {
        if (scheduleName != null) {
          const _itinerary = typeof event.Itinerary == "undefined" ? "Main" : event.Itinerary;
          if (_itinerary != scheduleName) continue;
        }
        let dateFilterTime = dates[j].value;
        //let dateFilterTime = dateFilter.getTime();
        //console.log("Find time match", dateStartTime, dateEndTime, dateFilterTime);
        //console.log("dateStartTime", dateStartTime, "dateFilterTime", dateFilterTime);
        if (
          dateStartTime == dateFilterTime ||
          dateEndTime == dateFilterTime ||
          (dateStartTime < dateFilterTime && dateEndTime > dateFilterTime)
        ) {
          const places = event.get_places(this.places);
          //console.log("Found time match", places.length);
          for (let k = 0; k < places.length; k++) {
            placesInSchedule.push(places[k]);
          }
        }
      }
    }
    return placesInSchedule;
  }

  getPlacesByLabelValue(
    sortBy,
    searchText,
    FilterVisited,
    FilterFavorites,
    DatesFilter,
    PlacesFilter,
    currentLocation,
    GroupsFilter,
    CategoriesFilter,
    section,
    SearchPlacesResults,
    FilterSearched,
    ShowHiddenPlaces,
    ScheduleName,
    FilterNotVisited,
    FilterMustSee,
    SchedulesFilter,
    GroupsHide,
    DistanceFilter,
    user_info,
    showHiddenPlace,
    PlaceTypeFilter
  ) {
    let filteredPlacesList = this.preFilterPlaces(
      searchText,
      FilterVisited,
      FilterFavorites,
      DatesFilter,
      PlacesFilter,
      currentLocation,
      GroupsFilter,
      CategoriesFilter,
      section,
      SearchPlacesResults,
      FilterSearched,
      ShowHiddenPlaces,
      ScheduleName,
      FilterNotVisited,
      FilterMustSee,
      SchedulesFilter,
      GroupsHide,
      DistanceFilter,
      user_info,
      showHiddenPlace,
      PlaceTypeFilter
    )["filteredPlacesList"];
    return this.places.sortPlacesByLabelValue(filteredPlacesList);
  }

  getPlacesToDisplay(
    sortBy,
    searchText,
    FilterVisited,
    FilterFavorites,
    DatesFilter,
    PlacesFilter,
    currentLocation,
    GroupsFilter,
    CategoriesFilter,
    Section,
    SearchPlacesResults,
    FilterSearched,
    ShowHiddenPlaces,
    ScheduleName,
    FilterNotVisited,
    FilterMustSee,
    SchedulesFilter,
    GroupsHide,
    DistanceFilter,
    user_info,
    showHiddenPlace,
    PlaceTypeFilter
  ) {
    let filteredPlacesList = this.preFilterPlaces(
      searchText,
      FilterVisited,
      FilterFavorites,
      DatesFilter,
      PlacesFilter,
      currentLocation,
      GroupsFilter,
      CategoriesFilter,
      Section,
      SearchPlacesResults,
      FilterSearched,
      ShowHiddenPlaces,
      ScheduleName,
      FilterNotVisited,
      FilterMustSee,
      SchedulesFilter,
      GroupsHide,
      DistanceFilter,
      user_info,
      showHiddenPlace,
      PlaceTypeFilter
    )["filteredPlacesList"];
    return this.sortPlaces(filteredPlacesList, sortBy, user_info, currentLocation);
    // switch (sortBy) {
    //   case SortByEnum.NAME:
    //     return this.sortPlacesByName(filteredPlacesList);
    //   case SortByEnum.CATEGORY:
    //     return this.sortPlacesByCategory(filteredPlacesList);
    //   case SortByEnum.GROUP:
    //     return this.sortPlacesByGroup(filteredPlacesList);
    //   case SortByEnum.DISTANCE:
    //     return this.sortPlacesByDistance(filteredPlacesList, currentLocation, user_info.distance_unit);
    //   case SortByEnum.RATING:
    //     return this.sortPlacesByRating(filteredPlacesList);
    //   case SortByEnum.DATE:
    //     return this.sortPlacesByDate(filteredPlacesList);

    //   default:
    //     return this.sortPlacesByName(filteredPlacesList);
    // }
  }

  sortPlaces(filteredPlacesList, sortBy, user_info, currentLocation) {
    switch (sortBy) {
      case SortByEnum.NAME:
        return this.sortPlacesByName(filteredPlacesList);
      case SortByEnum.CATEGORY:
        return this.sortPlacesByCategory(filteredPlacesList);
      case SortByEnum.GROUP:
        return this.sortPlacesByGroup(filteredPlacesList);
      case SortByEnum.DISTANCE:
        return this.sortPlacesByDistance(filteredPlacesList, currentLocation, user_info.distance_unit);
      case SortByEnum.RATING:
        return this.sortPlacesByRating(filteredPlacesList);
      case SortByEnum.DATE:
        return this.sortPlacesByDate(filteredPlacesList);

      default:
        return this.sortPlacesByName(filteredPlacesList);
    }
  }

  sortPlacesByName(filteredPlacesList) {
    let letters = [];
    for (let i = 0; i < filteredPlacesList.length; i++) {
      if (filteredPlacesList[i].Name == null || filteredPlacesList[i].Name == "") continue;
      letters.push(filteredPlacesList[i].Name.charAt(0).toUpperCase());
    }
    letters = Array.from(new Set(letters)).sort();
    let PlacesToDisplay = [];
    //console.log(letters);
    for (let cat_index = 0; cat_index < letters.length; cat_index++) {
      PlacesToDisplay.push({ Title: letters[cat_index], data: [] });
    }
    let id = 0;
    for (let i = 0; i < filteredPlacesList.length; i++) {
      if (filteredPlacesList[i].Name == null || filteredPlacesList[i].Name == "") continue;
      var first_char = filteredPlacesList[i].Name.charAt(0).toUpperCase();
      let section = PlacesToDisplay.find((x) => x.Title == first_char);
      if (section == null) continue;
      section.data.push({
        id: (id++).toString(),
        place: filteredPlacesList[i],
      });
    }
    for (let i = 0; i < PlacesToDisplay.length; i++)
      PlacesToDisplay[i].data.sort((a, b) => (a.place.Name.toUpperCase() < b.place.Name.toUpperCase() ? -1 : 1));
    return PlacesToDisplay;
  }

  sortPlacesByCategory(filteredPlacesList) {
    let categories = this.getCategoriesToDisplay(filteredPlacesList);
    // //console.log(categories);
    let PlacesToDisplay = [];
    for (let cat_index = 0; cat_index < categories.length; cat_index++) {
      PlacesToDisplay.push({ id: categories[cat_index].id, Title: categories[cat_index].name, data: [] });
    }
    let id = 0;
    for (let i = 0; i < filteredPlacesList.length; i++) {
      var place_cats = filteredPlacesList[i].getCategories();
      for (var j = 0; j < place_cats.length; j++) {
        if (place_cats[j] == "HTML_CONTENT") continue;
        let section = PlacesToDisplay.find((x) => x.id == place_cats[j]);
        if (section == null) continue;
        section.data.push({
          id: (id++).toString(),
          place: filteredPlacesList[i],
        });
      }
    }
    for (let i = 0; i < PlacesToDisplay.length; i++)
      PlacesToDisplay[i].data.sort((a, b) => (a.place.Name.toUpperCase() < b.place.Name.toUpperCase() ? -1 : 1));

    return PlacesToDisplay;
  }

  sortPlacesByGroup(filteredPlacesList) {
    let groups = this.getGroupsToDisplay(filteredPlacesList);
    let PlacesToDisplay = [];
    for (let group_index = 0; group_index < groups.length; group_index++) {
      PlacesToDisplay.push({ id: groups[group_index].id, Title: groups[group_index].name, data: [] });
    }
    let id = 0;
    for (let i = 0; i < filteredPlacesList.length; i++) {
      var place_groups = filteredPlacesList[i].getGroups();
      for (var j = 0; j < place_groups.length; j++) {
        if (place_groups[j] == "HTML_CONTENT") continue;
        let section = PlacesToDisplay.find((x) => x.id == place_groups[j]);
        if (section == null) continue;
        section.data.push({
          id: (id++).toString(),
          place: filteredPlacesList[i],
        });
      }
    }
    for (let i = 0; i < PlacesToDisplay.length; i++)
      PlacesToDisplay[i].data.sort((a, b) => (a.place.Name.toUpperCase() < b.place.Name.toUpperCase() ? -1 : 1));
    return PlacesToDisplay;
  }

  fixed(num) {
    if (num === 0) return num;
    else if (num <= 1) return num.toFixed(2);
    else if (num > 10) return num.toFixed();
    else return num.toFixed(1);
  }

  sortPlacesByDistance(filteredPlacesList, currentLocation, distance_unit) {
    if ((currentLocation == null || (currentLocation.latitude === 0 && currentLocation.longitude === 0)) && filteredPlacesList.length > 0)
      currentLocation = {
        latitude: parseFloat(filteredPlacesList[0].Lat),
        longitude: parseFloat(filteredPlacesList[0].Longi),
      };
    for (let i = 0; i < filteredPlacesList.length; i++) {
      let placeLocation = {
        latitude: parseFloat(filteredPlacesList[i].Lat),
        longitude: parseFloat(filteredPlacesList[i].Longi),
      };
      filteredPlacesList[i].Distance = Places.calculateDistance(currentLocation, placeLocation);
    }
    //console.log(filteredPlacesList);
    //filteredPlacesList = filteredPlacesList.sort(this.SortByDistanceMethod);

    let _distances = [
      0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 2, 3, 4, 5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000,
      2000, 5000, 10000, 99999999999,
    ];
    let distances = [];
    if (distance_unit === "miles") distance_unit = "mi";
    else distance_unit = "km";
    for (let i = 0; i < _distances.length; i++) {
      if (i < _distances.length - 2) distances.push(`${_distances[i]}-${_distances[i + 1]} ${distance_unit}`);
      else if (i == _distances.length - 2) distances.push(`${this.fixed(_distances[i])}+ ${distance_unit}`);
      //   if (i < _distances.length - 2)
      //   distances.push(
      //     `${_distances[i]}-${_distances[i + 1]} km (${this.fixed(_distances[i] * 0.62137119)}-${this.fixed(
      //       _distances[i + 1] * 0.62137119
      //     )} mi)`
      //   );
      // else if (i == _distances.length - 2)
      //   distances.push(`${this.fixed(_distances[i])}+ km (${this.fixed(_distances[i] * 0.62137119)}+ mi)`);
    }
    //console.log("distances", distances);
    // let distances = [
    //   "0-0.1 Km (0-0.06 mi)",
    //   "0.1-0.2 Km (0.06-0.12 mi)",
    //   "0.2-0.3 Km (0.12-0.19 mi)",
    //   "0.3-0.4 Km (0.19-0.25 mi)",
    //   "0.4-0.5 Km (0.25-0.31 mi)",
    //   "0.5-0.6 Km (0.31-0.37 mi)",
    //   "0.6-0.7 Km (0.37-0.43 mi)",
    //   "0.7-0.8 Km (0.43-0.5 mi)",
    //   "0.8-0.9 Km (0.5-0.56 mi)",
    //   "0.9-1 Km (0.56-0.62 mi)",
    //   "1-2 Km (0.62-1.2 mi)",
    //   "2-3 Km (1.2-1.9 mi)",
    //   "3-4 Km (1.9-2.4 mi)",
    //   "4-5 Km (2.4-3.1 mi)",
    //   "5-10 Km (3.1-6.2 mi)",
    //   "10-20 Km (6.2-12.4 mi)",
    //   "20-30 Km (12.4-18.6 mi)",
    //   "30-50 Km (18.6-31.1 mi)",
    //   "50-100 Km (31.1-62.1 mi)",
    //   "100-1,000 Km (62.1-621.4 mi)",
    //   "1,000+ Km (621.4+ mi)",
    // ];
    let PlacesToDisplay = [];
    for (let distance_index = 0; distance_index < distances.length; distance_index++) {
      PlacesToDisplay.push({ Title: distances[distance_index], data: [] });
    }
    let id = 0;
    let mi_adjust = 1;
    if (distance_unit == "mi") mi_adjust = 0.62137119;
    for (let i = 0; i < filteredPlacesList.length; i++) {
      let section = null;
      let distance = filteredPlacesList[i].Distance * mi_adjust;
      //adjust for distance = 0 place
      if (distance == 0) distance += 0.000001;
      //console.log(distance);
      for (let j = 0; j < _distances.length - 1; j++) {
        if (distance > _distances[j] && distance <= _distances[j + 1]) {
          section = PlacesToDisplay[j];
          break;
        }
      }

      if (section == null) continue;
      section.data.push({
        id: (id++).toString(),
        place: filteredPlacesList[i],
      });
    }

    // for (let i = 0; i < filteredPlacesList.length; i++) {
    //   let section = null;
    //   let distance = filteredPlacesList[i].Distance;
    //   //console.log(distance);
    //   if (distance < 0.25) section = PlacesToDisplay[0];
    //   else if (distance >= 0.25 && distance < 0.5) section = PlacesToDisplay[1];
    //   else if (distance >= 0.5 && distance < 0.75) section = PlacesToDisplay[2];
    //   else if (distance >= 0.75 && distance < 1) section = PlacesToDisplay[3];
    //   else if (distance >= 1 && distance < 2) section = PlacesToDisplay[4];
    //   else if (distance >= 2 && distance < 3) section = PlacesToDisplay[5];
    //   else if (distance >= 3 && distance < 5) section = PlacesToDisplay[6];
    //   else if (distance >= 5 && distance < 10) section = PlacesToDisplay[7];
    //   else if (distance >= 10 && distance < 30) section = PlacesToDisplay[8];
    //   else if (distance >= 30) section = PlacesToDisplay[9];
    //   if (section == null) continue;
    //   section.data.push({
    //     id: (id++).toString(),
    //     place: filteredPlacesList[i],
    //   });
    // }
    let lastWithData = PlacesToDisplay.length - 1;
    for (let i = PlacesToDisplay.length - 1; i >= 0; i--) {
      if (PlacesToDisplay[i].data.length != 0) break;
      lastWithData = i;
    }
    PlacesToDisplay = PlacesToDisplay.splice(0, lastWithData);
    let firstWithData = 0;
    for (let i = 0; i < PlacesToDisplay.length; i++) {
      if (PlacesToDisplay[i].data.length != 0) {
        firstWithData = i;
        break;
      }
    }
    PlacesToDisplay = PlacesToDisplay.splice(firstWithData, PlacesToDisplay.length);
    for (let i = 0; i < PlacesToDisplay.length; i++) {
      let data = PlacesToDisplay[i].data;
      data.sort((a, b) => a.place.Distance - b.place.Distance);
    }
    //console.log(PlacesToDisplay);
    return PlacesToDisplay;
  }

  sortPlacesByRating(filteredPlacesList, currentLocation) {
    //filteredPlacesList = filteredPlacesList.sort(this.SortByDistanceMethod);
    let ratings = ["4-5", "3-4", "2-3", "1-2", "0-1", "Unrated"];
    let PlacesToDisplay = [];
    for (let i = 0; i < ratings.length; i++) {
      PlacesToDisplay.push({ Title: ratings[i], data: [] });
    }
    let id = 0;
    for (let i = 0; i < filteredPlacesList.length; i++) {
      let section = null;
      let rating = filteredPlacesList[i].Rating;
      if (rating == 0) section = PlacesToDisplay[5];
      else if (rating >= 4) section = PlacesToDisplay[0];
      else if (rating >= 3 && rating < 4) section = PlacesToDisplay[1];
      else if (rating >= 2 && rating < 3) section = PlacesToDisplay[2];
      else if (rating >= 1 && rating < 2) section = PlacesToDisplay[3];
      else if (rating < 1 && rating < 2) section = PlacesToDisplay[4];
      if (section == null) continue;
      section.data.push({
        id: (id++).toString(),
        place: filteredPlacesList[i],
      });
    }
    for (let i = 0; i < 5; i++) {
      let data = PlacesToDisplay[i].data;
      data.sort((a, b) => b.place.Rating - a.place.Rating);
    }
    return PlacesToDisplay;
  }

  sortPlacesByDate(filteredPlacesList) {
    let dates = [];
    let dayStr = "";
    let section = null;
    let dayStrArr = null;
    for (let i = 0; i < filteredPlacesList.length; i++) {
      for (let j = 0; j < filteredPlacesList[i].scheduledDates.length; j++) {
        dayStrArr = filteredPlacesList[i].scheduledDates[j].split(":");
        dayStr = dayStrArr[0];
        if (!dates.includes(dayStr)) dates.push(dayStr);
      }
    }
    let PlacesToDisplay = [];
    for (let day_index = 0; day_index < dates.length; day_index++) {
      PlacesToDisplay.push({ Title: dates[day_index], data: [] });
    }
    PlacesToDisplay.push({ Title: "Not Scheduled", data: [] });
    //console.log(PlacesToDisplay);
    let id = 0;
    for (let i = 0; i < filteredPlacesList.length; i++) {
      if (filteredPlacesList[i].scheduledDates.length == 0) {
        section = PlacesToDisplay.find((x) => x.Title == "Not Scheduled");
        section.data.push({
          id: (id++).toString(),
          place: filteredPlacesList[i],
        });
      } else {
        for (let j = 0; j < filteredPlacesList[i].scheduledDates.length; j++) {
          //dayStr = Common.formatDate(filteredPlacesList[i].scheduledDates[j], false);
          dayStrArr = filteredPlacesList[i].scheduledDates[j].split(":");
          dayStr = dayStrArr[0];
          section = PlacesToDisplay.find((x) => x.Title == dayStr);
          if (section == null) continue;
          section.data.push({
            id: (id++).toString(),
            place: filteredPlacesList[i],
          });
        }
      }
    }
    for (let i = 0; i < PlacesToDisplay.length; i++) {
      if (PlacesToDisplay[i].Title == "Not Scheduled") continue;
      let data = PlacesToDisplay[i].data;
      data.sort((a, b) => new Date(a.place.start).getTime() - new Date(b.place.start).getTime());
    }
    return PlacesToDisplay;
  }

  preFilterPlaces(
    searchText,
    FilterVisited,
    FilterFavorites,
    DatesFilter,
    PlacesFilter,
    currentLocation,
    GroupsFilter,
    CategoriesFilter,
    Section,
    SearchPlacesResults,
    FilterSearched,
    ShowHiddenPlaces,
    ScheduleName,
    FilterNotVisited,
    FilterMustSee,
    SchedulesFilter,
    GroupsHide,
    DistanceFilter,
    user_info,
    showHiddenPlace,
    PlaceTypeFilter,
    CitiesFilter = [],
    FilterBucketList = false
    //separatePolylines
  ) {
    //console.log("GroupsFilter", GroupsFilter);
    //if (searchText == "") return this.places.placesList;
    //let polylinePlaces = [];
    //console.log("preFilterPlaces", showHiddenPlace);
    let allPlaces = this.places.placesList;
    if(typeof searchText === "undefined") return(allPlaces);
    const seachTextCap = searchText.toUpperCase();
    let placesInSchedule = [];
    if (DatesFilter.length != 0) {
      placesInSchedule = this.getPlacesinSchedule(DatesFilter, ScheduleName);
      //console.log("placesInSchedule.length:", placesInSchedule.length);
    }
    let _ScheduledPlaces = [];

    if (SchedulesFilter.length !== 0) {
      for (let s = 0; s < SchedulesFilter.length; s++) {
        _ScheduledPlaces = _ScheduledPlaces.concat(this.getAllScheduledPlaces(SchedulesFilter[s].label));
      }
      //_ScheduledPlaces = Array.from(new Set(_ScheduledPlaces));
      //console.log("_ScheduledPlaces", _ScheduledPlaces);
    }
    let filteredPlacesList = [];
    if (Section != null)
      allPlaces = this.getGroupAndCategoryPlaces(Section.PlaceIds, Section.Groups, Section.Categories);

    if (FilterSearched === "only_search") allPlaces = SearchPlacesResults;
    else if (FilterSearched === "all") allPlaces = allPlaces.concat(SearchPlacesResults);
    for (let i = 0; i < allPlaces.length; i++) {
      // Search results bypass all active filters so they always appear on the map
      if (isSearchResult(allPlaces[i].Source)) {
        filteredPlacesList.push(allPlaces[i]);
        continue;
      }
      //console.log("showHiddenPlace", showHiddenPlace);
      if (allPlaces[i].Hidden === true && ShowHiddenPlaces === false) continue;
      if (PlacesFilter.length !== 0) {
        if (!PlacesFilter.find((x) => x.ID === allPlaces[i].ID)) continue;
      }
      if (GroupsFilter.length !== 0 || GroupsHide.length !== 0) {
        var place_groups = allPlaces[i].getGroups();
        if (GroupsHide.length !== 0) {
          if (place_groups.some((r) => GroupsHide.indexOf(r) >= 0)) continue;
        }
        if (GroupsFilter.length !== 0) {
          if (!place_groups.some((r) => GroupsFilter.indexOf(r) >= 0)) continue;
        }
      }
      if (CategoriesFilter.length !== 0) {
        var place_cats = allPlaces[i].getCategories();
        //console.log("preFilterPlaces place_cats", place_cats);
        //console.log("place_cats, CategoriesFilter", place_cats, CategoriesFilter);
        if (!place_cats.some((r) => CategoriesFilter.indexOf(r) >= 0)) continue;
      }
      if (DatesFilter.length !== 0) {
        if (!placesInSchedule.find((x) => x.ID == allPlaces[i].ID)) continue;
      }
      if (FilterMustSee === true) if (allPlaces[i].MustSee !== true) continue;
      if (FilterBucketList === true) if (allPlaces[i].BucketList !== true) continue;
      if (FilterFavorites === true) if (allPlaces[i].Favorite !== true) continue;
      if (FilterVisited === true) if (allPlaces[i].Visited !== true) continue;
      if (FilterNotVisited === true) if (allPlaces[i].Visited === true) continue;
      if (SchedulesFilter.length > 0) {
        if (!_ScheduledPlaces.find((x) => x.ID === allPlaces[i].ID)) continue;
      }
      if (PlaceTypeFilter !== null && typeof PlaceTypeFilter !== "undefined") {
        if (PlaceTypeFilter.length > 0) {
          let found = false;
          for (let m = 0; m < PlaceTypeFilter.length; m++) {
            if (PlaceTypeFilter[m].value === allPlaces[i].PType) {
              found = true;
              break;
            }
          }
          if (found !== true) continue;
        }
      }
      if (CitiesFilter && CitiesFilter.length > 0) {
        const placeCity = (allPlaces[i].City || "").toUpperCase();
        if (!CitiesFilter.some((c) => c.value.toUpperCase() === placeCity)) continue;
      }
      if (seachTextCap !== "") {
        const place_cats_string = this.categoryNamesFromIDs(allPlaces[i].getCategories()).toUpperCase();
        if (place_cats_string.includes(seachTextCap)) {
          filteredPlacesList.push(allPlaces[i]);
          continue;
        }
        //console.log("searchText", seachTextCap, place_cats_string);
        const place_groups_string = this.groupNamesFromIDs(allPlaces[i].getGroups()).toUpperCase();
        if (place_groups_string.includes(seachTextCap)) {
          filteredPlacesList.push(allPlaces[i]);
          continue;
        }
        if (allPlaces[i].Name.toUpperCase().includes(seachTextCap)) {
          filteredPlacesList.push(allPlaces[i]);
          continue;
        }
        continue;
      }
      filteredPlacesList.push(allPlaces[i]);
    }
    //console.log("*******showHiddenPlace", showHiddenPlace);
    for (let m = 0; m < showHiddenPlace.length; m++) {
      const hiddenInList = filteredPlacesList.findIndex((p) => p.ID === showHiddenPlace[m].ID);
      if (hiddenInList === -1) {
        const index = allPlaces.findIndex((p) => p.ID === showHiddenPlace[m].ID);
        if (index !== -1) filteredPlacesList.push(allPlaces[index]);
      }
    }

    //console.log("placesInSchedule", placesInSchedule);
    let polylines = [];
    if (currentLocation == null || (currentLocation.latitude === 0 && currentLocation.longitude === 0)) {
      if (filteredPlacesList.length > 0)
        currentLocation = {
          latitude: parseFloat(filteredPlacesList[0].Lat),
          longitude: parseFloat(filteredPlacesList[0].Longi),
        };
    }
    let allScheduledPlaces = this.getAllScheduledPlaces(ScheduleName);
    for (let i = 0; i < filteredPlacesList.length; i++) {
      //console.log("filteredPlacesList[i].Points", filteredPlacesList[i].Points);
      // A polyline or polygon
      if (filteredPlacesList[i].PType != "Icon") {
        let polyline = Place.getPolyline(filteredPlacesList[i]);
        if (polyline != null) {
          //console.log(polyline);
          polyline.place = filteredPlacesList[i];
          polylines.push(polyline);
        }
      }
      if (currentLocation != null) {
        let placeLocation = {
          latitude: parseFloat(filteredPlacesList[i].Lat),
          longitude: parseFloat(filteredPlacesList[i].Longi),
        };
        filteredPlacesList[i].Distance = Places.calculateDistance(currentLocation, placeLocation);
      }

      filteredPlacesList[i].scheduledDates = [];
      filteredPlacesList[i].inSchedule = false;
      const scheduledPlace = allScheduledPlaces.find((x) => x.ID === filteredPlacesList[i].ID);
      if (scheduledPlace) {
        filteredPlacesList[i].inSchedule = true;
        for (let j = 0; j < scheduledPlace.scheduled.length; j++) {
          const scheduledDate = `${Common.formatDateLuxon(scheduledPlace.scheduled[j].start)}: ${Common.formatTimeLuxon(
            scheduledPlace.scheduled[j].start
          )}-${Common.formatTimeLuxon(scheduledPlace.scheduled[j].end)}`;
          filteredPlacesList[i].scheduledDates.push(scheduledDate);
        }
      }
    }
    if (DistanceFilter > -1) {
      let _filteredPlacesList = [];
      let _polylines = [];
      let miles_adjust = 1;
      if (user_info.distance_unit == "miles") miles_adjust = 1; //0.621371;
      //console.log("DistanceFilter > -1, miles_adjust: ", miles_adjust);
      for (let i = 0; i < filteredPlacesList.length; i++) {
        if (filteredPlacesList[i].Distance <= DistanceFilter / miles_adjust)
          _filteredPlacesList.push(filteredPlacesList[i]);
      }
      for (let i = 0; i < polylines.length; i++) {
        if (polylines[i].Distance <= DistanceFilter * miles_adjust) _polylines.push(polylines[i]);
      }
      //console.log("_filteredPlacesList", _filteredPlacesList);
      return { filteredPlacesList: _filteredPlacesList, polylines: _polylines };
    }
    //console.log("filteredPlacesList", filteredPlacesList);
    return { filteredPlacesList: filteredPlacesList, polylines: polylines };
  }

  createGuideHTML() {
    //disabled for now
    return "";
    //console.log("createGuideHTML", this.attributes);
    if (typeof this.attributes == "undefined") return "";
    let html_doc = "";
    const photoTouse = this.attributes.image_m != "" ? this.attributes.image_m : this.attributes.image;
    //if (photoTouse !== null) {
    const img = Common.getImageURL(photoTouse, null, true);
    html_doc += Common.coverImageHTML(img);
    //}
    //console.log("html_doc", html_doc);
    html_doc += `<p><h3 style="text-align:center;">${this.attributes.guide_name}</h3></p>`;
    //console.log("html_doc", html_doc);
    let cur_chapter = "";
    if (typeof this.chapters != "undefined") {
      html_doc += `<ol style="font-size:130%">`;
      for (let i = 0; i < this.chapters.length; i++) {
        if (typeof this.chapters[i].sections == "undefined") continue;
        html_doc += `<li style="background-color: #FFFF00">${this.chapters[i].Title}</li>`;
        html_doc += `<ul style="list-style-type:none">`;
        for (let j = 0; j < this.chapters[i].sections.length; j++) {
          //console.log("this.chapters", `${this.chapters[i].Title},${this.chapters[i].sections[j].Title}`);
          html_doc += `<li><a href="sectionlink:${this.chapters[i].sections[j].ID}">${this.chapters[i].sections[j].Title}</a></li>`;
        }
        html_doc += "</ul>";
      }
      html_doc += "</ol>";
    }
    //console.log("html_doc", html_doc);
    return html_doc;
  }

  // Round-trippable place fields not otherwise captured by KML's native name/
  // coordinates/description — read back by KMLInput.js's doParseGeoJSON on import.
  // "imgURL" keeps its existing name for backward compat with older exports/tools
  // that already produce it; everything else is new.
  _placeExtendedDataKML(place) {
    const cdata = (v) => `<![CDATA[${v == null ? "" : v}]]>`;
    const fields = {
      imgURL: place.Photo_m,
      imgURLFull: place.Photo,
      address: place.Address,
      city: place.City,
      state: place.State,
      country: place.Country,
      phone: place.Phone,
      email: place.Email,
      rating: place.Rating,
      duration: place.Duration,
      hlink: place.Hlink,
      poiImg: place.poi_img,
      favorite: place.Favorite,
      visited: place.Visited,
      mustSee: place.MustSee,
      hidden: place.Hidden,
      categories: this.categoryNamesFromIDs(place.Category, "||"),
      groups: this.groupNamesFromIDs(place.Group, "||"),
      link: JSON.stringify(place.Link || {}),
      openingHours: JSON.stringify(place.OpeningHours || {}),
    };
    const data = Object.entries(fields)
      .map(([name, value]) => `<Data name="${name}"><value>${cdata(value)}</value></Data>`)
      .join("\n              ");
    return `<ExtendedData>\n              ${data}\n            </ExtendedData>`;
  }

  createKML() {
    let kml = KMLTemplate;
    let placemarks = "";
    let placemark = "";
    for (let i = 0; i < this.places.placesList.length; i++) {
      let path = this.places.placesList[i].getKMLPath();
      const extendedData = this._placeExtendedDataKML(this.places.placesList[i]);
      if (path === null) {
        placemark = `
        <Placemark>
            <name>${this.places.placesList[i].Name}</name>
            <styleUrl>#icon-1899-0288D1-nodesc</styleUrl>
            ${extendedData}
            <Point>
              <coordinates>
                ${this.places.placesList[i].Longi},${this.places.placesList[i].Lat},0
              </coordinates>
              <description><![CDATA[${this.places.placesList[i].Info}]]>
              </description>
            </Point>
          </Placemark>`;
      } else {
        placemark = `
        <Placemark>
        <name>Line 1</name>
        <description>
        <![CDATA[${this.places.placesList[i].Info}]]>
        </description>
        <styleUrl>#line-E65100-7000-nodesc</styleUrl>
        ${extendedData}
        <LineString>
          <tessellate>1</tessellate>
          <coordinates>
          ${path}
        </coordinates>
        </LineString>
      </Placemark>
        `;
      }
      placemarks += placemark;
    }
    // Escaped: a name may now contain "&" (see the guide editor), which
    // would make the KML invalid XML. A function, so "$" in a name isn't
    // read as a replacement pattern.
    const kmlName = String(this.attributes.guide_name || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    kml = kml.replace("**KML_NAME**", () => kmlName);
    kml = kml.replace("**PLACEMARKS**", placemarks);

    return kml;
  }

  getGuideStatistics(){
    let stats = [];
    let places = this.places.placesList;
    for (let i = 0; i < places.length; i++) {
      let place = places[i];
      if(place.Country === "" || place.City === "") continue;
      if(place.Visited === false) continue;
      let found = false;
      for(let j = 0; j < stats.length; j++){
        if(stats[j].Country === place.Country && stats[j].City === place.City)
        {
          found = true;
          break;
        }
      }
      if(found === true) continue;
      let continent = "";
      let region = '';
      for(let k = 0; k < countries_continents.length; k++){
        if(countries_continents[k].country === place.Country){
          continent = countries_continents[k].continent;
          region = countries_continents[k].region;
          break;
        }
      }
      if(continent === "") continue;
      stats.push({
        Continent: continent,
        Country: place.Country,
        Region: region,
        State: "",
        City: place.City,
      })
    }
    // let countries = {names:[]};
    // let newlist = [];
    // for(let i = 0; i < regions.length; i++){
    //   let found_continent = "UNKNoWN";
    //   for(let k = 0; k < countries_continents.length; k++){
    //     if(countries_continents[k].country === regions[i].name){
    //       found_continent = countries_continents[k].continent;
    //       break;
    //     }
    //   }
    //     newlist.push({
    //       continent: found_continent, 
    //       country: regions[i].name,
    //       region: regions[i].id
    //   })
      
    // }
    //console.log(JSON.stringify(newlist));
    console.log('stats', stats);
    return stats;
  }

  // "All places" mosaic tile (2026-10-18): one tile with every place in the
  // guide, computed when the page is built so it never goes stale. Shown
  // when the mosaic has 2+ tiles and none of them already holds every place
  // (e.g. a hand-made "All" group). Guide Settings → Mosaic turns it off
  // (mosaic_all) and names it (mosaic_all_label). Same on mobile.
  static ALL_PLACES_KEY = "__all_places__";

  allPlacesTileLabel(guideSettings) {
    const l = String((guideSettings && guideSettings.mosaic_all_label) || "").trim();
    return l || "All places";
  }

  // True when one group or one schedule already holds every visible place,
  // so an "All places" tile would only repeat it.
  allPlacesCoveredByOneTile(visiblePlaces) {
    if (visiblePlaces.length === 0) return true;
    const ids = visiblePlaces.map((p) => String(p.ID));
    for (const g of this.groups || []) {
      if (!g.mosaic) continue;
      if (visiblePlaces.every((p) => (p.Group || []).some((x) => String(x) === String(g.id)))) return true;
    }
    for (const s of this.schedule.geScheduleNames()) {
      if (s.label === "Main") continue;
      const sched = new Set(this.getAllScheduledPlaces(s.label).map((p) => String(p.ID)));
      if (ids.every((id) => sched.has(id))) return true;
    }
    return false;
  }

  createHTMLItinerary(scheduleName, settings, userSettings, guideSettings, filterDate) {
    if (typeof settings === "undefined" || settings === null)
      settings = { info: true, photo: true, directions: true, place_menu: true, eventBody: true };
    if(settings.directions === false && settings.info === false &&  settings.photo === true && settings.place_menu === false)
    {
      console.log('createHTMLItinerary', 'Mosaic')
      ///////Mosaic/////
      let screen_width = 600;
      let screen_height = 800;
      let width = 100;
      let height = 125;
      let scale = 1;
      let fontScale = 1;
      let padding = 1;
      let adjust = 40;
      if(typeof window !== 'undefined'){ // running in browser
        screen_width = window.innerWidth;
        screen_height = window.innerHeight;
      }
      else
      {
       //width = useWindowDimensions().width;const {height, width, scale, fontScale} = useWindowDimensions();
        // screen_width = Dimensions.get("screen").width;
        // screen_height = Dimensions.get("screen").height;
        // scale = Dimensions.get("screen").scale;
        // fontScale = Dimensions.get("screen").fontScale;
        //console.log(screen_width, screen_height, scale, fontScale)
        adjust = 200;
        screen_width = Math.floor(screen_width*scale);
        screen_height = Math.floor(screen_height*scale);
      }
      width = Math.floor(((screen_width - 4*padding) - adjust)/3);
      if(width > 200 && (screen_width > screen_height)) width = 200;
      height = Math.floor(width*1.25);
      let num_chars = 16*(width/(100*scale));
      let main_page = "";
      let places = [];
      let main_schedules = [];
      let group_place = [];
      let AlreadyInList = [];
      // Tracks every photo URL already chosen as a tile's cover, so the next
      // tile prefers a different one instead of repeating it — a place that
      // belongs to more than one mosaic group (e.g. every destination's own
      // group AND the trip-wide "Guide" group) would otherwise supply the
      // identical photo to more than one tile, since both tiles' "first
      // matching place" is often the same place. Still falls back to a
      // repeated photo when a tile genuinely has no other candidate.
      // Requested 2026-09-27.
      let usedCoverPhotos = [];
      let filteredPlaces = this.places.getPlacesToDisplay(null);
      const skipHidden = !(userSettings && userSettings.showHiddenPlaces);

      if(scheduleName === "Main") {
        // Shared label-based deduplication (uppercased group name).
        // Also tracks each mosaic group's linked schedule (group.schedule),
        // since a group's own name and its linked schedule's name are not
        // kept in sync (see the Mosaic Schedules pass below).
        const linkedScheduleNames = new Set();

        // Mosaic Groups: all groups with mosaic===true (replaces old _m suffix convention)
        if (guideSettings ? guideSettings.mosaic_groups !== false : (!userSettings || userSettings.mosaic_groups !== false)) {
          // Collect every not-yet-listed group's candidate places first,
          // instead of locking in whichever place is encountered first —
          // lets the tile below prefer a candidate whose photo isn't
          // already used by an earlier tile (see usedCoverPhotos above).
          const candidatesByLabel = new Map(); // label -> { group, places: [] }
          for (let i = 0; i < filteredPlaces.length; i++) {
            if (skipHidden && filteredPlaces[i].Hidden === true) continue;
            const place = this.places.getPlace(filteredPlaces[i].value);
            if (place === null || (skipHidden && place.Hidden === true)) continue;
            for (let j = 0; j < place.Group.length; j++) {
              let group = this.getGroupByID(place.Group[j], "guide");
              if(group === null) continue;
              if(!group.mosaic) continue;
              if(group.name === "Bucket List_m") continue;
              const label = group.name.toUpperCase();
              if(AlreadyInList.includes(label)) continue;
              if (!candidatesByLabel.has(label)) candidatesByLabel.set(label, { group, places: [] });
              candidatesByLabel.get(label).places.push(place);
            }
          }
          for (const [label, { group, places: candidatePlaces }] of candidatesByLabel) {
            // Use group.image as cover if set, else use a representative place photo
            const photoOf = (p) => group.image || p.Photo_m || p.Photo || "";
            const chosen = candidatePlaces.find((p) => {
              const photo = photoOf(p);
              return photo && !usedCoverPhotos.includes(photo);
            }) || candidatePlaces[0];
            const repPhoto = photoOf(chosen);
            if (repPhoto) usedCoverPhotos.push(repPhoto);
            AlreadyInList.push(label);
            group_place.push({ group: group, place: chosen, coverPhoto: repPhoto, tileType: "group_m" });
            // Track the schedule this group is actually linked to (group.schedule),
            // not just its display name — a mosaic group is named after its bare
            // city (e.g. "Bologna") while its linked schedule gets a longer
            // auto-generated name (e.g. "Bologna, Italy Trip"), so the two labels
            // don't match even though the group tile already represents this
            // schedule's places. Found 2026-09-27: adding a destination via Build
            // My Trip showed both the group tile and a redundant schedule tile.
            if (group.schedule) linkedScheduleNames.add(group.schedule.toUpperCase());
          }
        }

        // Mosaic Schedules: one tile per schedule that has no linked mosaic group
        if (guideSettings ? guideSettings.mosaic_schedules !== false : (!userSettings || userSettings.mosaic_schedules !== false)) {
          const scheduleNames = this.schedule.geScheduleNames();
          for (let s = 0; s < scheduleNames.length; s++) {
            const schName = scheduleNames[s].label;
            if (schName === "Main") continue;
            const label = schName.toUpperCase();
            if (AlreadyInList.includes(label) || linkedScheduleNames.has(label)) continue;
            const schPlaces = this.getAllScheduledPlaces(schName);
            const hasPhoto = (p) => (!skipHidden || p.Hidden !== true) && ((p.Photo_m && p.Photo_m !== "") || (p.Photo && p.Photo !== ""));
            // Prefer a place whose photo isn't already used by an earlier
            // tile (see usedCoverPhotos above); fall back to the first
            // photo-bearing place if every candidate's photo is already used.
            const rep = schPlaces.find((p) => hasPhoto(p) && !usedCoverPhotos.includes(p.Photo_m || p.Photo))
              || schPlaces.find(hasPhoto);
            if (!rep) continue;
            AlreadyInList.push(label);
            usedCoverPhotos.push(rep.Photo_m || rep.Photo || "");
            // Synthetic group object carries schedule name via id
            group_place.push({
              group: { name: schName, id: "sch_" + schName, schedule: schName, mosaic: true, image: "" },
              place: rep,
              coverPhoto: rep.Photo_m || rep.Photo || "",
              tileType: "schedule",
            });
          }
        }

        group_place.sort((a, b) => (a.group.name.toUpperCase() > b.group.name.toUpperCase() ? 1 : -1));

        // "All places" tile, first (see ALL_PLACES_KEY above).
        const mosaicAll = guideSettings ? guideSettings.mosaic_all !== false : true;
        if (mosaicAll && group_place.length >= 2) {
          const visible = [];
          for (let i = 0; i < filteredPlaces.length; i++) {
            if (skipHidden && filteredPlaces[i].Hidden === true) continue;
            const place = this.places.getPlace(filteredPlaces[i].value);
            if (place === null || (skipHidden && place.Hidden === true)) continue;
            visible.push(place);
          }
          if (!this.allPlacesCoveredByOneTile(visible)) {
            const guideCover = (guideSettings && guideSettings.mosaic_all_image) || (this.attributes && (this.attributes.image_m || this.attributes.image)) || "";
            const photoOf = (p) => p.Photo_m || p.Photo || "";
            const rep = visible.find((p) => photoOf(p) && !usedCoverPhotos.includes(photoOf(p))) || visible.find((p) => photoOf(p)) || visible[0];
            group_place.unshift({
              group: { name: this.allPlacesTileLabel(guideSettings), id: Guide.ALL_PLACES_KEY },
              place: rep,
              coverPhoto: guideCover || photoOf(rep),
              tileType: "all",
            });
          }
        }
      } else if (scheduleName === Guide.ALL_PLACES_KEY) {
        // The "All places" page: every visible place.
        for (let i = 0; i < filteredPlaces.length; i++) {
          if (skipHidden && filteredPlaces[i].Hidden === true) continue;
          const place = this.places.getPlace(filteredPlaces[i].value);
          if (place === null || (skipHidden && place.Hidden === true)) continue;
          group_place.push({ group: { name: this.allPlacesTileLabel(guideSettings) }, place: place, coverPhoto: place.Photo_m || place.Photo || "", tileType: "group" });
        }
        group_place.sort((a, b) => (a.place.Name.toUpperCase() > b.place.Name.toUpperCase() ? 1 : -1));
      } else if (scheduleName.endsWith("_gm")) {
        // Sub-page for a mosaic group (identified by groupID + _gm suffix)
        const groupID_gm = scheduleName.slice(0, -3);
        for (let i = 0; i < filteredPlaces.length; i++) {
          if (skipHidden && filteredPlaces[i].Hidden === true) continue;
          const place = this.places.getPlace(filteredPlaces[i].value);
          if (place === null || (skipHidden && place.Hidden === true)) continue;
          for (let j = 0; j < place.Group.length; j++) {
            if (place.Group[j] !== groupID_gm) continue;
            const group = this.getGroupByID(place.Group[j], "guide");
            if (group === null) continue;
            group_place.push({ group: group, place: place, coverPhoto: place.Photo_m || place.Photo || "", tileType: "group" });
          }
        }
        group_place.sort((a, b) => (a.place.Name.toUpperCase() > b.place.Name.toUpperCase() ? 1 : -1));
      } else {
        // Sub-page: look up group by ID (stored in scheduleName directly) or fall back to schedule
        // scheduleName here is either a group ID or a schedule-derived name
        let groupFound = null;
        for (let g = 0; g < this.groups.length; g++) {
          if (this.groups[g].id === scheduleName) { groupFound = this.groups[g]; break; }
        }
        if (groupFound !== null) {
          for (let i = 0; i < filteredPlaces.length; i++) {
            if (skipHidden && filteredPlaces[i].Hidden === true) continue;
            const place = this.places.getPlace(filteredPlaces[i].value);
            if (place === null || (skipHidden && place.Hidden === true)) continue;
            if (!place.Group.includes(groupFound.id)) continue;
            group_place.push({ group: groupFound, place: place, coverPhoto: place.Photo_m || place.Photo || "", tileType: "group_m" });
          }
        } else {
          // Legacy _m or schedule fallback
          const realScheduleName = scheduleName.endsWith("_m") ? scheduleName.slice(0, -2) : scheduleName;
          // Try finding a group whose schedule matches
          const linkedGroup = this.groups.find(g => g.schedule === realScheduleName && g.mosaic);
          if (linkedGroup) {
            for (let i = 0; i < filteredPlaces.length; i++) {
              if (skipHidden && filteredPlaces[i].Hidden === true) continue;
              const place = this.places.getPlace(filteredPlaces[i].value);
              if (place === null || (skipHidden && place.Hidden === true)) continue;
              if (!place.Group.includes(linkedGroup.id)) continue;
              group_place.push({ group: linkedGroup, place: place, coverPhoto: place.Photo_m || place.Photo || "", tileType: "group_m" });
            }
          } else {
            // Pure schedule fallback
            const schPlaces = this.getAllScheduledPlaces(realScheduleName);
            for (const p of schPlaces) {
              if (skipHidden && p.Hidden === true) continue;
              group_place.push({ group: { name: scheduleName, schedule: realScheduleName }, place: p, coverPhoto: p.Photo_m || p.Photo || "", tileType: "schedule" });
            }
          }
        }
        group_place.sort((a, b) => (a.place.Name.toUpperCase() > b.place.Name.toUpperCase() ? 1 : -1));
      }

      const imgStyle = `width:100%;height:${height}px;object-fit:cover;border-radius:10%;margin:0;display:block;background:#E8E8E8;`;
      const btnStyle = `border:none;background:none;padding:${padding}px;font-size:70%;display:flex;flex-direction:column;align-items:center;gap:4px;width:100%;cursor:pointer;`;
      const labelStyle = `display:block;width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-align:center;font-size:0.85em;`;
      for (let m = 0; m < group_place.length; m++)
      {
        const gp = group_place[m];
        let Photo = Common.getImageURL(gp.coverPhoto || gp.place.Photo_m || gp.place.Photo || "", null, true);
        let PhotoFallback = Common.getImageURL(gp.place.Photo || "", null, true);
        const imgFallbackAttr = `data-photo="${PhotoFallback}" onerror="window.imgFallback(this)"`;
        if(scheduleName === "Main"){
          const grp = gp.group;
          // Display label: use group name (strip trailing _m for legacy groups)
          let group_label = grp.name.endsWith("_m")
            ? grp.name.slice(0, grp.name.lastIndexOf("_m"))
            : grp.name;
          group_label = group_label.substring(0, num_chars);

          if (gp.tileType === "all") {
            main_page += `<a href="itinerarylink:${Guide.ALL_PLACES_KEY}"><button style="${btnStyle}"><img style="${imgStyle}" src="${Photo}" referrerpolicy="no-referrer" ${imgFallbackAttr} /><span style="${labelStyle}">${group_label}</span></button></a>`;
          } else if (gp.tileType === "schedule") {
            // Schedule without a linked mosaic group: use _m suffix convention for sub-page
            main_page += `<a href="itinerarylink:${grp.name}_m"><button style="${btnStyle}"><img style="${imgStyle}" src="${Photo}" referrerpolicy="no-referrer" ${imgFallbackAttr} /><span style="${labelStyle}">${group_label}</span></button></a>`;
          } else {
            // Mosaic group (mosaic===true): open sub-page via _gm suffix with group ID
            main_page += `<a href="itinerarylink:${grp.id}_gm"><button style="${btnStyle}"><img style="${imgStyle}" src="${Photo}" referrerpolicy="no-referrer" ${imgFallbackAttr} /><span style="${labelStyle}">${group_label}</span></button></a>`;
          }
        }
        else {
          let place_label = gp.place.Name.substring(0, num_chars);
          // A place without a map location opens its details instead of
          // centring the map on nothing (2026-10-17).
          const onMap = (Number.isFinite(parseFloat(gp.place.Lat)) && Number.isFinite(parseFloat(gp.place.Longi)) && !(parseFloat(gp.place.Lat) === 0 && parseFloat(gp.place.Longi) === 0));
          const placeLink = !onMap
            ? `placelink:${gp.place.ID}`
            : (gp.tileType === "schedule" || gp.tileType === "group")
            ? `maplink:${gp.place.ID}|||center`
            : `maplink:${gp.place.ID}||`;
          main_page += `<a href="${placeLink}"><button style="${btnStyle}"><img style="${imgStyle}" src="${Photo}" referrerpolicy="no-referrer" ${imgFallbackAttr} /><span style="${labelStyle}">${place_label}</span></button></a>`;
        }
      }
      const mosaicScript = `
        window.customLink = function(url) { if (window.parent && window.parent.customLink) window.parent.customLink(url); };
        window.imgFallback = function(img) {
          var photo = img.getAttribute('data-photo');
          if (photo && img.src !== photo) { img.removeAttribute('data-photo'); img.src = photo; }
          else { img.onerror = null; img.src = 'https://andiamotravelapp.com/Images/App/IllustratedImage.jpg'; }
        };
        document.addEventListener('click', function(e) {
          var a = e.target.closest('a[href]');
          if (!a) return;
          var href = a.getAttribute('href');
          if (!href || href.startsWith('http://') || href.startsWith('https://')) return;
          e.preventDefault();
          window.customLink(href);
        });
        function reportHeight() {
          var h = document.documentElement.scrollHeight || document.body.scrollHeight;
          if (h > 0) window.parent.postMessage({ type: 'mosaicHeight', height: h }, '*');
        }
        window.addEventListener('load', reportHeight);
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(reportHeight).observe(document.body);
        }
      `.trim();
      if(main_page === "") {
        main_page = "The current guide format is 'Mosaic'. To make photos appear on this page, open Groups, select a group that has places associated with it and enable the Mosaic option.";
      } else {
        main_page = `<div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:2px;padding:4px;width:100%;box-sizing:border-box;">${main_page}</div>`;
      }
      return `<!DOCTYPE html><html><head><meta charset="utf-8"><style>*{box-sizing:border-box;}html,body{margin:0;padding:0;width:100%;background:#FAFAFA;font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif;}body{padding-bottom:32px;}</style></head><body>${main_page}<script>${mosaicScript}</script></body></html>`;
    }
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    let font_size = isMobile ? "100%" : "100%";
    let h_size = "h3";
    let last_place = null;
    // if (window.web_app) h_size = "h5";
    if (scheduleName == null) scheduleName = "Main";
    scheduleName = scheduleName.replace(/%20/g, " ");
    // let html_doc = `<div style="font-size: ${font_size};"><p style="text-align:center;"><h2><a href="maplink:|||schedule=${scheduleName}">Schedule: ${scheduleName}</a></h2></p>`;
    const _itin_title = filterDate
      ? `Today: ${DateTime.fromISO(filterDate, { zone: "utc" }).toFormat("ccc, MMMM d, yyyy")}`
      : `Itinerary: ${scheduleName}`;
    let html_doc = `<p style="text-align:center;"><h2><a href="maplink:|||schedule=${scheduleName}">${_itin_title}</a></h2></p>`;
    //let html_doc = `<p style="text-align:center;"><${h_size}>${scheduleName}</${h_size}></p>`;
    let day = -1;
    let dayNum = 0;

    this.schedule.events = this.schedule.events.sort(
      (a, b) => new Date(a.Start).getTime() - new Date(b.Start).getTime()
    );
    for (let i = 0; i < this.schedule.events.length; i++) {
      const event = this.schedule.events[i];
      const _scheduleName = typeof event.Itinerary == "undefined" ? "Main" : event.Itinerary;
      if (_scheduleName != scheduleName) continue;
      //let startDate = new Date(event.Start);
      var startDate = DateTime.fromISO(event.Start, { zone: "utc" });
      if (filterDate && startDate.toISODate() !== filterDate) continue;
      //let endDate = new Date(event.End);
      var endDate = DateTime.fromISO(event.End, { zone: "utc" });
      if (day != startDate.day) {
        dayNum += 1;
        // UTC midnight of startDate's wall-clock day, matching getAllScheduledPlaces'
        // day-boundary — not the device's local midnight (see comment there).
        let dateLinkTime = startDate.startOf("day").toMillis();
        // filterDate limits the whole itinerary to a single day, so the "Today: ..."
        // title above already says which day it is — a "Day N: ..." line here is redundant.
        if (!filterDate) {
          html_doc += `<p><h2><a href="maplink:|||day=${dateLinkTime}">Day ${dayNum}: ${Common.formatDateLuxon(
            startDate
          )}</a></h2></p>`;
        }

        //html_doc += `<p><${h_size}>${Common.formatDateLuxon(startDate)}</${h_size}></p>`;
        day = startDate.day;

        let today_dateTime = DateTime.fromISO(event.Start, { zone: "utc" });
        //today_dateTime.setHours(0, 0, 0, 0);
        let dateTime = today_dateTime.valueOf();
        const places = this.getPlacesinSchedule(
          [{ label: Common.formatDateLuxon(startDate), value: dateTime }],
          scheduleName
        );
        //console.log("createHTMLItinerary, places:", places);
        let path = "";
        let markers = "";
        // //console.log("places.length", places.length);
        let places_string = "";
        let _index = 0;
        for (let m = 0; m < places.length; m++) {
          if (typeof places[m].Name === "undefined") continue;
          places_string += places_string == "" ? places[m].ID : "," + places[m].ID;
          let _path = places[m].getPath();
          if (_path == null) {
            if (markers == "")
              markers = `&markers=size:mid%7Ccolor:red%7Clabel:${labelChars[_index]}%7C${places[m].Lat},${places[m].Longi}`;
            else
              markers += `|&markers=size:mid%7Ccolor:red%7Clabel:${labelChars[_index]}%7C${places[m].Lat},${places[m].Longi}`;
            _index += 1;
          } else {
            if (places[m].PType == "Polygon") {
              const points = _path.split(":");
              if (points.length > 2) {
                if (points[1] != points[points.length - 1]) _path += ":" + points[1];
              }
            }
            let path_type = `&path=color:0xff0000ff|weight:2`;
            if (places[m].PType == "Polygon") path_type = "&path=fillcolor:0x0000FF33%7Ccolor:0x0000ff33%|weight:2";
            if (path == "") path = `${path_type}${_path}`;
            else path += `|${_path}`;
          }
        }
        places_string += "||";
        let static_map = `https://maps.googleapis.com/maps/api/staticmap?size=400x300&scale=2&maptype=roadmap${markers}${path}&key=${process.env.REACT_APP_GOOGLE_MAPS_STATIC_API}`;
        //console.log(path, markers);
        if (path != "" || markers != "")
          html_doc += `<a href="maplink:${places_string}||"><img src="${static_map}" alt="Map" style="width:100%; max-width:700px; height:auto; border-radius:10%" onerror="window.imgFallback(this)"></img></a><br/><br/>`;
        // html_doc += `<p><strong>Places today:</strong></p>`;
        if (places.length > 0) html_doc += "<ol>";
        for (let j = 0; j < places.length; j++) {
          if (typeof places[j].Name === "undefined") continue;
          if (places[j].PType != "Icon")
            html_doc += `<a href="placemenulink:${places[j].ID}">${places[j].Name}${
              places[j].MustSee == true ? "*" : ""
            }</a><br>`;
        }
        _index = 0;
        for (let j = 0; j < places.length; j++) {
          if (typeof places[j].Name === "undefined") continue;
          if (places[j].PType == "Icon") {
            html_doc += `<a href="placemenulink:${places[j].ID}">${labelChars[_index]}. ${places[j].Name}${
              places[j].MustSee == true ? "*" : ""
            }</a><br>`;
            _index += 1;
          }
        }
        if (places.length > 0) html_doc += "</ol>";
      }
      const places = event.get_places(this.places);
      // Small, non-intrusive, opt-in (off by default) — one pair per event,
      // tied to the same place Directions below uses as its destination,
      // not repeated per place in a multi-place event. Added 2026-09-10.
      if ((settings.weather === true || settings.climate === true) && places.length > 0 && typeof places[0].Name !== "undefined") {
        html_doc += `<small style="color:#888888;">`;
        if (settings.weather === true) html_doc += `<a href="weatherlink:${places[0].ID}">Weather</a>`;
        if (settings.weather === true && settings.climate === true) html_doc += " &middot; ";
        if (settings.climate === true) html_doc += `<a href="climatelink:${places[0].ID}">Climate</a>`;
        html_doc += `</small><br>`;
      }
      if (settings.directions === true) {
        if (last_place !== null) {
          if (places.length > 0 && typeof places[0].Name !== "undefined" && typeof last_place.Name !== "undefined")
            html_doc += `<a href="directionslink:${last_place.ID}|${places[0].ID}">Directions from: ${last_place.Name} to: ${places[0].Name}</a><br>`;
        }
      }
      if (places.length > 0) last_place = places[0];
      html_doc += `<br><strong>${Common.formatTimeLuxon(startDate)}-${Common.formatTimeLuxon(endDate)}</strong>`;
      html_doc += `<p><strong>${event.Subject}</strong></p>`;
      // event.Body (the AI's own generated description for this scheduled
      // visit) and each place's Info/Notes (which can independently gain
      // Wikipedia text via "Find Place Info", etc.) are two different
      // sources that can both describe the same place — showing both looked
      // like a duplicate even though neither field literally copies the
      // other. Automated creation (TripAI.js/BuildMyTripWizard.js) passes
      // eventBody: false to show only place.Info; manual itinerary
      // generation (ScheduleHeader.js's ItinSettings dialog) exposes this as
      // a checkbox so the user decides. Fixed 2026-08-29 — see memory:
      // project_cost_revenue_viability.
      if (settings.eventBody !== false && event.Body !== "" && typeof event.Body !== "undefined") html_doc += `${event.Body}<br/>`;
      // for (let j = 0; j < places.length; j++) {
      //   html_doc += `<a href="placemenulink:${places[j].ID}"><li>${places[j].Name}</li></a>`;
      // }

      // for (let j = 0; j <div places.length; j++) {
      //   if (places[j].PType != "Icon")
      //     html_doc += `<a href="placemenulink:${places[j].ID}">${places[j].Name}${
      //       places[j].MustSee == true ? "*" : ""
      //     }</a><br>`;
      // }
      if (settings.place_name !== undefined) {
        // New mode: per-place rendering in order — name, info, photo
        for (let j = 0; j < places.length; j++) {
          if (typeof places[j].Name === "undefined") continue;
          if (settings.place_name === true) {
            html_doc += `<p><strong><a href="placemenulink:${places[j].ID}">${places[j].Name}${places[j].MustSee === true ? "*" : ""}</a></strong></p>`;
          }
          if (settings.info === true) {
            // Wrapped in its own block — Info's raw HTML (e.g. a Wikipedia
            // enrichment blurb ending bare at "...See more on Wikipedia</a>",
            // see placeEnrichment.js) was concatenated directly against the
            // NEXT place's <p>Name</p> with no separator at all, so a
            // selection spanning the two copied as one run-together string.
            // A <p>/<a> boundary alone isn't enough — only a real block
            // element reliably forces a break. Found 2026-10-05.
            if (places[j].Info !== "" && typeof places[j].Info !== "undefined") html_doc += `<div style="margin-bottom:14px;">${places[j].Info}</div>`;
          }
          if (settings.photo === true) {
            const _info = places[j].Info || "";
            // ".jpg"/".JPG" only catches Wikimedia-style URLs — Google's
            // thumbnailLink and proxied img_proxy.php URLs have no file
            // extension at all, so that check missed them and appended a
            // second, duplicate photo whenever Info already embedded one of
            // those. Checking for any <img tag instead catches every source.
            // Fixed 2026-08-29 — see memory: project_cost_revenue_viability.
            if ((places[j].Photo_m || places[j].Photo) && !_info.toLowerCase().includes("<img")) {
              const photoToUse = places[j].Photo_m && places[j].Photo_m !== "" ? Place.proxyImageUrl(places[j].Photo_m) : places[j].Photo;
              html_doc += Place.createImageHTML(photoToUse, null, "medium", undefined, places[j].Photo);
            }
          }
        }
      } else {
        // Backward-compat mode: photo controls both info and photo; place_menu at end
        if (settings.photo === true) {
          for (let j = 0; j < places.length; j++) {
            if (typeof places[j].Name === "undefined") continue;
            // Wrapped in its own block — same fix as the "New mode" branch
            // above, same reasoning: the next place's raw Info (or photo)
            // concatenated directly with no separator otherwise.
            if (places[j].Info !== "" && typeof places[j].Info !== "undefined") html_doc += `<div style="margin-bottom:14px;">${places[j].Info}</div>`;
            // See the "New mode" branch above for why this checks for any
            // <img tag rather than just ".jpg"/".JPG".
            if ((places[j].Photo_m || places[j].Photo) && !(places[j].Info || "").toLowerCase().includes("<img")) {
              const photoToUse = places[j].Photo_m && places[j].Photo_m !== "" ? Place.proxyImageUrl(places[j].Photo_m) : places[j].Photo;
              html_doc += Place.createImageHTML(photoToUse, null, "medium", undefined, places[j].Photo);
            }
          }
        }
        if (settings.place_menu === true) {
          if (places.length > 0) {
            let _index = 0;
            html_doc += "<br><ol>";
            for (let j = 0; j < places.length; j++) {
              if (typeof places[j].Name === "undefined") continue;
              html_doc += `<a href="placemenulink:${places[j].ID}">${labelChars[_index]}. ${places[j].Name}${
                places[j].MustSee === true ? "*" : ""
              }</a><br>`;
              _index += 1;
            }
            html_doc += "</ol><br>";
          }
        }
      }
      //html_doc += "</div>";
    }
    //html_doc += "</p>";
    //</body></html>`;
    //console.log('html_doc', html_doc);
    if(html_doc === "")
      html_doc = "Nothing here yet. Add destinations to build your trip, or tap Edit to write this page yourself."; // plain wording (2026-10-23)
    return html_doc;
  }
}
